import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
// import { Provinces } from '../../pages/master/master-constant';

export interface Obj {
  value: string;
  viewValue: string;
}

@Injectable({
  providedIn: 'root',
})
export class DataService {

  constructor( 
    private router:Router,
    private http: HttpClient, 
    // private provinces: Provinces, 
    public snackBar: MatSnackBar, 
  ){ 

  }

  
  msgErr001 = "Data not found !";
  msgErr002 = "Data not unique !";

  msgWarn0001 = "Please select date !";
  msgWarn0002 = "Please select date after ";
  msgWarn0003 = "Please fill the Expense total";

  btnTitle1 = "Close";
  btnClose  = "Close";


  reportDay   = "DAY";
  reportMonth = "MONTH";

  KCC_TTB_BOOK1   = "1952346011";
  KCC_TTB_BOOK2   = "1952346672";
  KCC_KBANK_BOOK1 = "1988541210";
  
  KCC_BOOK = {
    1952346011: "195-2-34601-1",
    1952346672: "195-2-34667-2",
    1988541210: "198-8-54121-0",
  };

  KCC_BOOK_NAME = {
    1952346011: "ทหารไทยธนชาต จำกัด (มหาชน)",
    1952346672: "ทหารไทยธนชาต จำกัด (มหาชน)",
    1988541210: "กสิกรไทย จำกัด (มหาชน) ",
  };

  monthEng: Obj[] = [
    { value: "1",  viewValue: "January"  },
    { value: "2",  viewValue: "February" },
    { value: "3",  viewValue: "March"    },
    { value: "4",  viewValue: "April"    },
    { value: "5",  viewValue: "May"      },
    { value: "6",  viewValue: "June"     },
    { value: "7",  viewValue: "July"     },
    { value: "8",  viewValue: "August"   },
    { value: "9",  viewValue: "September"},
    { value: "10", viewValue: "October"  },
    { value: "11", viewValue: "November" },
    { value: "12", viewValue: "December" },
  ];

  monthThai: Obj[] = [
    { value: "1",  viewValue: "มกราคม"   },
    { value: "2",  viewValue: "กุมภาพันธ์"  },
    { value: "3",  viewValue: "มีนาคม"    },
    { value: "4",  viewValue: "เมษายน"   },
    { value: "5",  viewValue: "พฤษภาคม" },
    { value: "6",  viewValue: "มิถุนายน"   },
    { value: "7",  viewValue: "กรกฎาคม"  },
    { value: "8",  viewValue: "สิงหาคม"   },
    { value: "9",  viewValue: "กันยายน"   },
    { value: "10", viewValue: "ตุลาคม"    },
    { value: "11", viewValue: "พฤศจิกายน" },
    { value: "12", viewValue: "ธันวาคม"   },
  ];

  ceirYear: Obj[] = [
    { value: "2026",  viewValue: "2026"  },
    { value: "2025",  viewValue: "2025"  },
    { value: "2024",  viewValue: "2024"  },
    { value: "2023",  viewValue: "2023"  },
    { value: "2022",  viewValue: "2022"  },
    { value: "2021",  viewValue: "2021"  },
    { value: "2020",  viewValue: "2020"  },
  ];
  
  pvYear: Obj[] = [
    { value: "2026",  viewValue: "2026"  },
    { value: "2025",  viewValue: "2025"  },
    { value: "2024",  viewValue: "2024"  },
    { value: "2023",  viewValue: "2023"  },
    { value: "2022",  viewValue: "2022"  },
    { value: "2021",  viewValue: "2021"  },
  ];

  incrementalInvestment: Obj[] =[
    { value: "COURT"    , viewValue: "ค่าธรรมเนียมศาล" },
    { value: "LAWYER"   , viewValue: "ค่าทนายความ" },
    { value: "EXECUTION", viewValue: "ค่าใช้จ่ายกรมบังคับคดี" },
    { value: "BROKER"   , viewValue: "ค่านายหน้า" },
  ];

  orgSueCase: Obj[] = [
    { value: "0",  viewValue: "ยังไม่ฟ้อง" },
    { value: "1",  viewValue: "ฟ้อง - ดำเนินคดี" },
    { value: "2",  viewValue: "ฟ้อง - พิพากษา" },
    { value: "3",  viewValue: "ฟ้อง - บังคับคดี" },
    { value: "4",  viewValue: "ฟ้อง - ขายทอดตลาด" }
  ];

  reqCloseType: Obj[] = [
    { value: "NORMAL",  viewValue: "ปกติ" },
    { value: "ZERO",    viewValue: "ตัดหนี้ศูนย์" },
    { value: "SELL",    viewValue: "ขายหนี้" },
  ];


  CLT_TRAN_FLAG = {
    Redeem  : "RDM",    //-- จ่ายเงินปิด
    Sell    : "SELL",   //-- ขายทอดตลาด
    Sold    : "SOLD",   //-- 
    Convert : "CVT",    //-- ตีทรัพย์ชำระหนี้
    NPA     : "NPA"     //-- ยกซื้อ NPA
  }

  REQ_TYPE = {
    CloseAccount     : "CLS-ACC",
    WaiveDefault     : "WAV-DEF",
    CloseCollatral   : "CLS-CLT",
    SellCollatral    : "SELL-CLT",
    CancelReceipt    : "CANCEL-RECP",
    CollatralToMoney : "CLT-TO-MONEY",
    CollatralToNPA   : "CLT-TO-NPA",
    NewPortfolio     : "NEW-PF",
    ImportDebtors    : "IMP-DT",
    ImportCollateral : "IMP-CLT",

    //for template
    RequestTemplate  : "T-REQ",
    // -- 
  }
  
  //-- 29 Dec 2022
  appNotificationType: Obj[] = [
    { value: "info",      viewValue: "info" },
    { value: "warning",   viewValue: "warning" },
    { value: "danger",    viewValue: "danger" },
  ];

  //-- 3 Jan 2023
  appUserStatus: Obj[] = [
    { value: "pending",     viewValue: "pending" },
    { value: "submitted",   viewValue: "submitted" },
    { value: "approved",    viewValue: "approved" },
    { value: "rejected",    viewValue: "rejected" },
    { value: "blocked",     viewValue: "blocked" },
  ];

  //-- 19 Jan 2023
  portType: Obj[] = [
    { value: "HOU",     viewValue: "Housing" },
    { value: "SME",     viewValue: "SME" },
    { value: "COR",     viewValue: "Corporate" },
  ];

  //-- 14 Mar 2023
  appNewNotiType: Obj[] = [
    { value: "All Users",    viewValue: "All Users" },
    { value: "User Group",   viewValue: "User Group" },
    { value: "User",         viewValue: "User" },
  ];

  //-- ==================================
  //--  IS VALID CSV FILE
  //-- ==================================
  isCSVFile( file: any ) {
    return file.name.endsWith(".csv");
  }
  //-- ==================================
  //--  IS OBJ USEABLE
  //-- ==================================
  // isData( obj ){
  //   var isData = true;
  //   if( 
  //     obj == null      || 
  //     obj == undefined || 
  //     obj == ""        || 
  //     obj.lenght == 0 // ||
  //     //obj.trim() == ""
  //   ){
  //     isData = false;
  //   }
  //   return isData;
  // }
  isData(obj: any): boolean {
    if (
      obj === null ||
      obj === undefined ||
      (typeof obj === 'string' && obj.trim().length === 0) ||
      (Array.isArray(obj) && obj.length === 0)
    ) {
      return false;
    }
    return true;
  }
  //-- ==================================
  //--  Get Thai Month
  //-- ==================================
  toThaiMonth( month: Number) {
    var monthThai = "";
    for( var x in this.monthThai ){
      if( this.monthThai[ x ].value == month.toString() ){
        monthThai = this.monthThai[ x ].viewValue;
      }
    }
    return monthThai;
  }
  //-- ==================================
  //--  Generate Empty line for PDF report
  //-- ==================================
  generateEmptyPDFLine( collumnCount ){
    var line = [];
    for( var i=0 ; i<collumnCount ; i++ ){
      line.push( {} );
    }
    return line;
  }
  //-- ==================================
  //--  get Description of Original Sue Case
  //-- ==================================
  getOrgSueCaseDescripiton( sueCase: String ){
    var description = "";
    for( var x in this.orgSueCase ){
      if( this.orgSueCase[ x ].value == sueCase ){
        description = this.orgSueCase[ x ].viewValue;
      }
    }
    return description;
  }
  getOrgSueCaseKey( sueDescription: String ){
    var key = "";
    for( var x in this.orgSueCase ){
      if( this.orgSueCase[ x ].viewValue == sueDescription ){
        key = this.orgSueCase[ x ].value;
      }
    }
    return key;
  }
  //-- ==================================

  getReqCloseType( closeType ){
    var desc = "";
    for( var x in this.reqCloseType ){
      if( this.reqCloseType[ x ].value == closeType ){
        desc = this.reqCloseType[ x ].viewValue;
        break;
      }
    }
    return desc;
  }
  //-- ==================================

  getReqCloseKey( closeDescription ){
    var key = "";
    for( var x in this.reqCloseType ){
      if( this.reqCloseType[ x ].viewValue == closeDescription ){
        key = this.reqCloseType[ x ].value;
        break;
      }
    }
    return key;
  }
  //-- ==================================
  formatNumber( value, decimal ){
    if( value ){
      value *= 100;
      value = Math.round(value);
      value /= 100;

      var sValue = value.toFixed(decimal);
      var parts  = sValue.split(".");

      parts[0]  = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }else{
      return 0;
    }
  }
  //-- ==================================
  parseFloat( val ){
    let n = Number(val);
    return isNaN(n) ? 0 : n;
  }
  //-- ==============================================================================================
  //-- ~ Message
  openSnackBar( message: string, action: string ) {
    this.snackBar.open( message, action, {
      duration: 2000,
    });
  }
  //-- ==============================================================================================
  //-- ~
  //-- ==============================================================================================
  numberWithCommas( x ){
    var value = x * 100;
        value = Math.round(value);
        value /= 100;
    var parts = value.toString().split(".");
    parts[0]  = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  //-- ==============================================================================================
  numberWithCommasDecial( x, decimal ){
    var value = x * 100;
        value = Math.round(value);
        value /= 100;

    var sValue = value.toFixed(decimal);
    var parts  = sValue.split(".");


    parts[0]  = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  //-- ==============================================================================================
  //-- ~
  //-- ==============================================================================================
  displayBookBank( bookId ){
    var txtBook = "";
    if( this.KCC_BOOK[ bookId ] ){
      txtBook = this.KCC_BOOK[ bookId ];
    }
    return txtBook;
  }
  //-- ==============================================================================================
  //-- ~
  //-- ==============================================================================================
  getIncrementalInvestmentViewValue( aKey ){
    var lv_return = "";
    for( var x in this.incrementalInvestment ){
      if( this.incrementalInvestment[ x ][ "value" ] == aKey ){
        lv_return = this.incrementalInvestment[ x ][ "viewValue" ];
        break;
      }
    }
    return lv_return;
  }
  //-- ==============================================================================================
  //-- ~
  //-- ==============================================================================================
  cleanProvince( province ){

    province = province.replace( "จังหวัด", "" );
    province = province.replace( "จ."   , "" );
    return province;

  }
  //-- ==============================================================================================
  //-- getRegion
  //-- ==============================================================================================
  getRegion( province ){

    var allProvinces = this.ProvinceandRegionComprehensive;
    var region       = "";
    var bkk          = "กรุงเทพมหานคร";

    province = province.replace( "จ."         , "จังหวัด" );
    province = province.replace( "จ.กรุงเทพฯ"  , bkk     );
    province = province.replace( "กรุงเทพฯ"    , bkk     );

    if( province != "กรุงเทพมหานคร" ){
      if( province == province.replace( "จังหวัด", "" ) ){
        province = "จังหวัด" + province;
      }
    }
    
    for( var x in allProvinces ){

      var provObj = allProvinces[ x ];

      if( province == provObj.ProvinceNameThai ){
        region = provObj.Region_RDPB;
        break;
      }
    }
    
    return region;

  }//-- END : getRegion
  //-- ==============================================================================================
  //-- getMaintenanceType
  //-- ==============================================================================================
  getNPAMaintenanceType( maType ){
    var maTypeDisplay = "";

    try{
      if( maType >= 0 && maType <= 3 ){
        maTypeDisplay = this.NPAMaintenanceTypes[ maType ];
      }
    }catch(err){
      console.log(err);
    }
    return maTypeDisplay;    
  }
  //-- ======================================
  NPAMaintenanceTypes = [
    "[- select one -]",
    "ค่าซ่อมแซม",
    "ค่ากำจัดปลวก",
    "ค่าตัดต้นไม้/ทำความสะอาด",
    "ค่าตัดกุญแจ",
    "ค่าใช้จ่ายอื่นๆ"
  ]
  //-- ==============================================================================================
  //-- getUtilityType
  //-- ==============================================================================================
  getNPAUtilityType( utilType ){
    var utilTypeDisplay = "";

    try{
      if( utilType >= 0 && utilType <= 3 ){
        utilTypeDisplay = this.NPAUtilityTypes[ utilType ];
      }
    }catch(err){
      console.log(err);
    }
    return utilTypeDisplay;    
  }
  //-- ======================================
  NPAUtilityTypes = [
    "[- select one -]",
    "ค่าภาษีที่ดิน",
    "ค่าส่วนกลาง",
    "ค่าน้ำ",
    "ค่าไฟ",
    "ค่าใช้จ่ายอื่นๆ",
  ]
  //-- ==============================================================================================
  //-- Array for report
  //-- ==============================================================================================
  extractAttributeKeys( obj ) {
    const firstKey = Object.keys(obj)[0]; // หาคีย์แรกของ object
    return firstKey ? Object.keys(obj[firstKey]) : []; // ดึงชื่อ attribute
  }
  //-- ======================================
  extractNestedAttributeKeys( obj ) {
    const firstKey = Object.keys(obj)[0]; // หาคีย์แรกของ object
    if (!firstKey || !Array.isArray(obj[firstKey])) return []; // ตรวจสอบว่ามีข้อมูลและเป็น array
    
    const firstItem = obj[firstKey][0]; // ดึงข้อมูลชุดแรกจาก array ภายใน
    return firstItem ? Object.keys(firstItem) : []; // ดึงชื่อ attribute จาก object ตัวแรก
  }
  //-- ======================================
  extractAttributesFromArray(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return []; // ตรวจสอบว่าเป็น array และไม่ว่าง
    
    const firstItem = arr[0]; // ดึง object ตัวแรกของ array
    return firstItem ? Object.keys(firstItem) : []; // ดึงชื่อ attribute จาก object ตัวแรก
  }
  //-- ======================================
  appendAttributeKeys(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return arr; // ตรวจสอบว่าเป็น array และไม่ว่าง
    
    const firstItem = arr[0]; // ดึง object ตัวแรกของ array
    const attributeKeys = Object.keys(firstItem).reduce((obj, key) => {
        obj[key] = key; // กำหนดให้ key เป็นค่า value
        return obj;
    }, {});

    return [...arr, attributeKeys]; // เพิ่ม object นี้ลงไปเป็นแถวสุดท้าย
  }
  //-- ==============================================================================================
  //-- ~
  //-- ==============================================================================================
  ProvinceandRegionComprehensive = [
    {
        "ProvinceNo": "01",
        "ProvinceMOI_ID": "10",
        "ProvinceNameThai": "กรุงเทพมหานคร",
        "Region_VaccineRollout_MOPH": "กรุงเทพมหานครและปริมณฑล",
        "Region_RDPB": "กรุงเทพมหานคร",//"ภาคกลาง",
        "Region_RedCrossChapter": "N/A",
        "Region_SenatorFieldWork": "N/A",
        "Region_JFO": "ส่วนกลาง",
        "Region_TCGOffice": "สำนักงานเขตนครหลวง",
        "RegionID": "7",
        "RegionName": "ส่วนกลาง",
        "ProvincialClusterID": "71",
        "ProvincialClusterName": "ส่วนกลาง",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ส่วนกลาง",
        "RegionOPSIndustry": "ส่วนกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "กองบัญชาการตำรวจนครบาล",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดกรุงเทพมหานคร",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 13",
        "RegionEnvironment": "ส่วนกลาง",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "ส่วนกลาง",
        "WaterAuthorities_ServiceArea": "การประปานครหลวง",
        "RegionWaterAuthorities": "N/A",
        "RegionElectricityAuthorities": "การไฟฟ้านครหลวง",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 1, เขตพื้นที่การศึกษามัธยมศึกษา เขต 2",
        "RegionFineArts": "ส่วนกลาง",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานกรุงเทพมหานคร",
        "RegionAppealCourt": "ศาลอุทธรณ์",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบกลาง",
        "RegionPACC": "ส่วนกลาง",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 10",
        "RegionCGDOffice": "ส่วนกลาง",
        "RegionRD": "สำนักงานสรรพากรภาค 1, สำนักงานสรรพากรภาค 2, สำนักงานสรรพากรภาค 3",
        "RegionVillageFund": "ส่วนกลาง",
        "StateAuditRegionalOffice": "ส่วนกลาง",
        "RegionPRD": "ส่วนกลาง",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 2",
        "RegionHealthPromotionCenter": "สถาบันพัฒนาสุขภาวะเขตเมือง",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 13",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 13 กรุงเทพมหานคร",
        "RegionDisaster": "ส่วนกลาง",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 1",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 11",
        "RegionDSI": "ส่วนกลาง",
        "RegionDLD": "ส่วนกลาง",
        "Region_CustomHouse": "N/A",
        "Region_CustomsBureau": "สำนักงานศุลกากรกรุงเทพ, สำนักงานศุลกากรท่าอากาศยานดอนเมือง, สำนักงานศุลกากรตรวจสินค้าลาดกระบัง, สำนักงานศุลกากรท่าเรือกรุงเทพ",
        "Region_CAD": "ส่วนกลาง",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ส่วนกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการส่วนกลาง",
        "Region_DMR": "ส่วนกลาง",
        "Region_DIP": "ส่วนกลาง",
        "Region_NESDC_NationalAccounts": "กรุงเทพมหานครและปริมณฑล",
        "Region_NESDC_RegionalOffice": "ส่วนกลาง",
        "Region_BudgetBureauDivision": "ส่วนกลาง",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษากรุงเทพมหานคร เขต 1, เขตพื้นที่การศึกษามัธยมศึกษากรุงเทพมหานคร เขต 2",
        "Region_SSOProvincialOffice": "สำนักงานประกันสังคมกรุงเทพมหานครพื้นที่ 1 -12",
        "Region_InspectionArea_CPD": "เขตตรวจราชการส่วนกลาง",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 1",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการส่วนกลาง",
        "Region_BACCDepartment": "สำนักกิจการนครหลวง",
        "Region_SAT": "ส่วนกลาง",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานกรุงเทพมหานคร",
        "Region_OPSTourismandSports": "ส่วนกลาง",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำท่าจีน, ลุ่มน้ำบางปะกง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการส่วนกลาง",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 1 จังหวัดปทุมธานี",
        "Region_DMSC": "ส่วนกลาง ",
        "Region_DDC": "N/A",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ส่วนกลาง",
        "Region_OCSB": "N/A",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ส่วนกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "N/A",
        "Region_IrrigationOffice": "ส่วนกลาง",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "ส่วนกลาง",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 8",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 11",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "ส่วนกลาง",
        "Region_MD_MarineOffice": "ส่วนกลาง",
        "Region_ThailandPost": "สำนักงานไปรษณีย์นครหลวง 1, สำนักงานไปรษณีย์นครหลวง 2, สำนักงานไปรษณีย์นครหลวง 3, สำนักงานไปรษณีย์นครหลวง 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 11 (ตลิ่งชัน), ศูนย์ความปลอดภัยในการทำงานเขต 12 (มีนบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "02",
        "ProvinceMOI_ID": "81",
        "ProvinceNameThai": "จังหวัดกระบี่",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 11",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนบน",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "22",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอันดามัน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันตก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 8",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 8",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 11",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 15",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 6 (ตรัง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 4",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคใต้) จังหวัดนครศรีธรรมราช",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 11",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 13",
        "RegionFineArts": "สำนักศิลปากรที่ 12 นครศรีธรรมราช",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานกระบี่",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 8",
        "RegionAdministrativeCourt": "ศาลปกครองภูเก็ต",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 8",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 8",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 8",
        "RegionCGDOffice": "สำนักงานคลังเขต 8",
        "RegionRD": "สำนักงานสรรพากรภาค 11",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 9",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 14",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 5",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 6",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 11 นครศรีธรรมราช",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 11",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 11 สุราษฎร์ธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 18 ภูเก็ต",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 10",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 8",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 43",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 8",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรกระบี่",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 8",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 7",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 6",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 5",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาตรัง กระบี่",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 6",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 17",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 14 พังงา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอันดามัน",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 20 จังหวัดสุราษฎร์ธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 11/1 ภูเก็ต",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 11 จังหวัดนครศรีธรรมราช",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 6",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ ตรัง",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 3",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 12 สาขากระบี่",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 15",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 10",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 10",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 42",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขากระบี่",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 5",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 8",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 8 (สุราษฎร์ธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 4 ภูเก็ต"
    },
    {
        "ProvinceNo": "03",
        "ProvinceMOI_ID": "71",
        "ProvinceNameThai": "จังหวัดกาญจนบุรี",
        "Region_VaccineRollout_MOPH": "ภาคตะวันตก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 4",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันตก",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "13",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันตก",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 7",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 7",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 5",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 8",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 3",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคกลาง) จังหวัดนครปฐม",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 10",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 8",
        "RegionFineArts": "สำนักศิลปากรที่ 2 สุพรรณบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานกาญจนบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 7",
        "RegionAdministrativeCourt": "ศาลปกครองสุพรรณบุรี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 7",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 7",
        "RegionCGDOffice": "สำนักงานคลังเขต 7",
        "RegionRD": "สำนักงานสรรพากรภาค 6",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 12",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 12",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 3",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 5 ราชบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 5",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 5 ราชบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 2 สุพรรณบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 3",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 10",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 17",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 7",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 7",
        "Region_CustomHouse": "ด่านศุลกากรสังขละบุรี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 10",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 3",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันตก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 13",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษากาญจนบุรี",
        "Region_SSOProvincialOffice": "ภาคตะวันตก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 3",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 2 จังหวัดราชบุรี",
        "Region_MonkMahaNikai": "ภาค 14",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 3",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันตก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 3 เพชรบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำท่าจีน, ลุ่มน้ำแม่กลอง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 3",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 15 จังหวัดเพชรบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 5 สมุทรสงคราม",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 5 จังหวัดราชบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันตก",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคตะวันตก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 (ราชบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 13",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันตก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 7",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 13",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขากาญจนบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 3",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 7",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 7 (ราชบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "04",
        "ProvinceMOI_ID": "46",
        "ProvinceNameThai": "จังหวัดกาฬสินธุ์",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 7",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "53",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนกลาง",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 7",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 10",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 4 (ขอนแก่น)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 6",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุบลราชธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 5",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 24",
        "RegionFineArts": "สำนักศิลปากรที่ 9 อุบลราชธานี",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานขอนแก่น",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองขอนแก่น",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 4",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 7",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 12",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 7 ขอนแก่น",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 7",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 7 ขอนแก่น",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 6 ขอนแก่น",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 6",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 4",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 23",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรมุกดาหาร",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 4",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 12",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 5 จังหวัดขอนแก่น",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 8",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษากาฬสินธุ์",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 12",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 9",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 12",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 10 ขอนแก่น",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวธรณีวิทยาถิ่นอีสาน",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 12",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 8 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 7 ขอนแก่น",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 7 จังหวัดขอนแก่น",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 (ขอนแก่น)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 6",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 4",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 21",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาขอนแก่น",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "05",
        "ProvinceMOI_ID": "62",
        "ProvinceNameThai": "จังหวัดกำแพงเพชร",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 8",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "64",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 3",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 4",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 7 (กำแพงเพชร)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคเหนือ) จังหวัดพิษณุโลก",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 9",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 41",
        "RegionFineArts": "สำนักศิลปากรที่ 6 สุโขทัย",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสุโขทัย",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองพิษณุโลก",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 6",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 7",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 2",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 11",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 18",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 3 นครสวรรค์",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 3",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 3 นครสวรรค์",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 8 กำแพงเพชร",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 8",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 12",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 31",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรแม่สอด",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 6",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 2",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 18",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 3 จังหวัดพิจิตร",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 18",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษากำแพงเพชร",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 18",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 4",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 4 - 5 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 18",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 6 พิษณุโลก",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวมรดกโลกด้านวัฒนธรรม",
        "RiverBasin": "ลุ่มน้ำปิง, ลุ่มน้ำยม, ลุ่มน้ำน่าน, ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำสะแกกรัง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 18",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 14 จังหวัดชัยนาท",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 3 นครสวรรค์",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 3 จังหวัดนครสวรรค์",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 4 (ตาก)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 4",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 1",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 35",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครสวรรค์",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 6",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "06",
        "ProvinceMOI_ID": "40",
        "ProvinceNameThai": "จังหวัดขอนแก่น",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 6",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "53",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนกลาง",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 7",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 10",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 4 (ขอนแก่น)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 6",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุดรธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 5",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 25",
        "RegionFineArts": "สำนักศิลปากรที่ 8 ขอนแก่น",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานขอนแก่น",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองขอนแก่น",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 5",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 7",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 12",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 7 ขอนแก่น",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 7",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 7 ขอนแก่น",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 6 ขอนแก่น",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 5",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 4",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 23",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรหนองคาย",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 5",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 12",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 5 จังหวัดขอนแก่น",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 8",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาขอนแก่น",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 12",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 9",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 12",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 10 ขอนแก่น",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวธรณีวิทยาถิ่นอีสาน",
        "RiverBasin": "ลุ่มน้ำชี, ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 12",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 7 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 7 ขอนแก่น",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 7 จังหวัดขอนแก่น",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 (ขอนแก่น)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 6",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 4",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 21",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาขอนแก่น",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "07",
        "ProvinceMOI_ID": "22",
        "ProvinceNameThai": "จังหวัดจันทบุรี",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 3",
        "Region_SenatorFieldWork": "ภาคตะวันออก",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออก",
        "RegionID": "4",
        "RegionName": "ภาคตะวันออก",
        "ProvincialClusterID": "42",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออก 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออก",
        "RegionTMD": "ภาคตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคตะวันออก",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 2",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 2",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 6",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 13",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออก",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 9 (ระยอง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 1",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคกลาง) จังหวัดชลบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 2",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 17",
        "RegionFineArts": "สำนักศิลปากรที่ 5 ปราจีนบุรี",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานจันทบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 2",
        "RegionAdministrativeCourt": "ศาลปกครองระยอง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 2",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 2",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 9",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 6 ชลบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 6",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 6 ระยอง",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 17 จันทบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 2",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 19",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 2",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "ด่านศุลกากรจันทบุรี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 6",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 9",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 3",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาจันทบุรี ตราด",
        "Region_SSOProvincialOffice": "ภาคตะวันออก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 9",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 13",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 12 - 13 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 5 ระยอง",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวฝั่งทะเลตะวันออก",
        "RiverBasin": "ลุ่มน้ำบางปะกง, ลุ่มน้ำโตนเลสาบ, ลุ่มน้ำชายฝั่งทะเลตะวันออก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 3 จังหวัดชลบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 6 ชลบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 6 จังหวัดชลบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออก",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 4",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 3",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดจันทบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคตะวันออก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 9 (ชลบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 9",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 6",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 1",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 12",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาจันทบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 2 (ชลบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "08",
        "ProvinceMOI_ID": "24",
        "ProvinceNameThai": "จังหวัดฉะเชิงเทรา",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 3",
        "Region_SenatorFieldWork": "ภาคตะวันออก",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออก",
        "RegionID": "4",
        "RegionName": "ภาคตะวันออก",
        "ProvincialClusterID": "41",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออก 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออก",
        "RegionTMD": "ภาคตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคตะวันออก",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 2",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 2",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 6",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 13",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออก",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 9 (ระยอง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 1",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคกลาง) จังหวัดชลบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 2",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 6",
        "RegionFineArts": "สำนักศิลปากรที่ 5 ปราจีนบุรี",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานฉะเชิงเทรา",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 2",
        "RegionAdministrativeCourt": "ศาลปกครองระยอง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 2",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 2",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 8",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 6 ชลบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 6",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 6 ระยอง",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 3 ปราจีนบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 2",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 12",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 2",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "N/A",
        "Region_CustomsBureau": "สำนักงานศุลกากรกรุงเทพ",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 6",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 8",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 1",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาฉะเชิงเทรา",
        "Region_SSOProvincialOffice": "ภาคตะวันออก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 8",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 12",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "ภาค 12 - 13 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 8",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 4 ฉะเชิงเทรา",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตชายฝั่งอ่าวไทย",
        "RiverBasin": "ลุ่มน้ำบางปะกง, ลุ่มน้ำชายฝั่งทะเลตะวันออก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 8",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 4 จังหวัดนครนายก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 6 ชลบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 6 จังหวัดชลบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออก",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 4",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 3",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดจันทบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคตะวันออก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 9 สาขาปราจีนบุรี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 9, สำนักงานชลประทานที่ 11",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 6",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 2",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 14",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาฉะเชิงเทรา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 10 (สมุทรปราการ)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "09",
        "ProvinceMOI_ID": "20",
        "ProvinceNameThai": "จังหวัดชลบุรี",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 3",
        "Region_SenatorFieldWork": "ภาคตะวันออก",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออก",
        "RegionID": "4",
        "RegionName": "ภาคตะวันออก",
        "ProvincialClusterID": "41",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออก 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออก",
        "RegionTMD": "ภาคตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคตะวันออก",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 2",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 2",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 6",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 13",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออก",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 9 (ระยอง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 1",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคกลาง) จังหวัดชลบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 2",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 18",
        "RegionFineArts": "สำนักศิลปากรที่ 5 ปราจีนบุรี",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานพัทยา",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 2",
        "RegionAdministrativeCourt": "ศาลปกครองระยอง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 2",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 2",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 8",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 6 ชลบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 6",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 6 ระยอง",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 17 จันทบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 2",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 14",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 2",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "ด่านศุลกากรมาบตาพุด",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1, สำนักงานศุลกากรท่าเรือแหลมฉบัง",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 6",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 8",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 1",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาชลบุรี ระยอง",
        "Region_SSOProvincialOffice": "ภาคตะวันออก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 8",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 13",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 12 - 13 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 8",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 5 ระยอง",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวฝั่งทะเลตะวันออก",
        "RiverBasin": "ลุ่มน้ำบางปะกง, ลุ่มน้ำชายฝั่งทะเลตะวันออก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 8",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 3 จังหวัดชลบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 6 ชลบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 6 จังหวัดชลบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออก",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 4",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 3",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดจันทบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคตะวันออก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 9 (ชลบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 9",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 6",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 2",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 12",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาชลบุรี, สำนักงานเจ้าท่าภูมิภาคสาขาพัทยา ",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 2 (ชลบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "10",
        "ProvinceMOI_ID": "18",
        "ProvinceNameThai": "จังหวัดชัยนาท",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 2",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "11",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนบน",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 3",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 5",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคเหนือ) จังหวัดลพบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 5",
        "RegionFineArts": "สำนักศิลปากรที่ 4 ลพบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานลพบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองนครสวรรค์",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 1",
        "RegionCGDOffice": "สำนักงานคลังเขต 1",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 13",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 11",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 1",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 3 นครสวรรค์",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 3",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 3 นครสวรรค์",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 16 ชัยนาท",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 7",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 13",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 1",
        "Region_CustomHouse": "ด่านศุลกากรสังขละบุรี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 1",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 3 จังหวัดพิจิตร",
        "Region_NESDC_NationalAccounts": "ภาคกลาง",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 12",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาอุทัยธานี ชัยนาท",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 1",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 3",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคกลาง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำท่าจีน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 13 จังหวัดชัยนาท",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 3 นครสวรรค์",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 3 จังหวัดนครสวรรค์",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 5 (สระบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 10, สำนักงานชลประทานที่ 12",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 13",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสุพรรณบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 1",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 1 (พระนครศรีอยุธยา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "11",
        "ProvinceMOI_ID": "36",
        "ProvinceNameThai": "จังหวัดชัยภูมิ",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 5",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "54",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 3",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 3",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 9",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 11",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 5 (นครราชสีมา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 6",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคตะวันออกเฉียงเหนือ) จังหวัดนครราชสีมา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 3",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 30",
        "RegionFineArts": "สำนักศิลปากรที่ 10 นครราชสีมา",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครราชสีมา",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 3",
        "RegionAdministrativeCourt": "ศาลปกครองนครราชสีมา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 3",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 3",
        "RegionRD": "สำนักงานสรรพากรภาค 9",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 5",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 4",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 13",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 9 นครราชสีมา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 9",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 9 นครราชสีมา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 5 นครราชสีมา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 4",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 5",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 21",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 3",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 3",
        "Region_CustomHouse": "ด่านศุลกากรท่าลี่",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 3",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 13",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 6 จังหวัดนครราชสีมา",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 9",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาชัยภูมิ",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 13",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 11",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 13",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 11 นครราชสีมา",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวธรณีวิทยาถิ่นอีสาน",
        "RiverBasin": "ลุ่มน้ำชี, ลุ่มน้ำมูล, ลุ่มน้ำป่าสัก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 13",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 5 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 9 นครราชสีมา",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 9 จังหวัดนครราชสีมา",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 2",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 8 (นครราชสีมา)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 6",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 4",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 23",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครราชสีมา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 3",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 3 (นครราชสีมา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "12",
        "ProvinceMOI_ID": "86",
        "ProvinceNameThai": "จังหวัดชุมพร",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 11",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนบน",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "21",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอ่าวไทย",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 8",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 8",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 11",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 14",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 6 (ตรัง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 4",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคใต้) จังหวัดเพชรบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 11",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 11",
        "RegionFineArts": "สำนักศิลปากรที่ 12 นครศรีธรรมราช",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานชุมพร",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 8",
        "RegionAdministrativeCourt": "ศาลปกครองนครศรีธรรมราช",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 8",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 8",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 8",
        "RegionCGDOffice": "สำนักงานคลังเขต 8",
        "RegionRD": "สำนักงานสรรพากรภาค 11",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 9",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 13",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 5",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 5",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 11 นครศรีธรรมราช",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 11",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 11 สุราษฎร์ธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 11 สุราษฎร์ธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 10",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 8",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 44",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 8",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรชุมพร",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 8",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 7",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 5",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 4",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสุราษฎร์ธานี ชุมพร",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 5",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 16",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 16 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 13 สุราษฎร์ธานี",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวฝั่งทะเลตะวันตก",
        "RiverBasin": "ลุ่มน้ำเพชรบุรี - ประจวบคีรีขันธ์, ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 19 จังหวัดสุราษฎร์ธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 11 สุราษฎร์ธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 11 จังหวัดนครศรีธรรมราช",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 6",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ สงขลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 3",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 11 (สุราษฎร์ธานี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 14",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 10",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 4 ",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 45",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาชุมพร",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 4",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 8",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 8 (สุราษฎร์ธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 4 ภูเก็ต"
    },
    {
        "ProvinceNo": "13",
        "ProvinceMOI_ID": "57",
        "ProvinceNameThai": "จังหวัดเชียงราย",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 10",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนบน)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนบน",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "62",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนบน 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 5",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 5",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 1",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 1",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 1 (ลำปาง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 9",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคเหนือ) จังหวัดเชียงใหม่",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 7",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 36",
        "RegionFineArts": "สำนักศิลปากรที่ 7 เชียงใหม่",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานเชียงราย",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 5",
        "RegionAdministrativeCourt": "ศาลปกครองเชียงใหม่",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 5",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 5",
        "RegionRD": "สำนักงานสรรพากรภาค 8",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 1",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 8",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 3",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 16",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 1 เชียงใหม่",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 1",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 1 เชียงใหม่",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 15 เชียงราย",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 9",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 1",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือบน",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 37",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 5",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 5",
        "Region_CustomHouse": "ด่านศุลกากรเชียงของ, ด่านศุลกากรเชียงแสน, ด่านศุลกากรแม่สาย",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 7",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 1",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 16",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 1 จังหวัดเชียงใหม่",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 17",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาเชียงราย",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 16",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 6",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 6 - 7 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 16",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 8 พะเยา",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมล้านนา",
        "RiverBasin": "ลุ่มน้ำโขงเหนือ, ลุ่มน้ำวัง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 16",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 10 จังหวัดลำปาง",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 1/1 เชียงราย",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 1 จังหวัดเชียงใหม่",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 1",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ เชียงใหม่",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 5",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 2 (เชียงราย)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 2",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 1",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 34",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาเชียงราย",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 5 (ลำปาง)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 3 เชียงใหม่"
    },
    {
        "ProvinceNo": "14",
        "ProvinceMOI_ID": "50",
        "ProvinceNameThai": "จังหวัดเชียงใหม่",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 10",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนบน)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนบน",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "61",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 5",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 5",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 1",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 1",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 1 (ลำปาง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 9",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคเหนือ) จังหวัดเชียงใหม่",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 6",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 34",
        "RegionFineArts": "สำนักศิลปากรที่ 7 เชียงใหม่",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานเชียงใหม่",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 5",
        "RegionAdministrativeCourt": "ศาลปกครองเชียงใหม่",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 5",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 5",
        "RegionRD": "สำนักงานสรรพากรภาค 8",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 1",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 8",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 3",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 15",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 1 เชียงใหม่",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 1",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 1 เชียงใหม่",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 10 ลำปาง",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 9",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 1",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือบน",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 33",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 5",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 5",
        "Region_CustomHouse": "ด่านศุลกากรเชียงดาว, ด่านศุลกากรท่าอากาศยานเชียงใหม่",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 7",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 1",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 15",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 1 จังหวัดเชียงใหม่",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 10",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาเชียงใหม่",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 15",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 7",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 6 - 7 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 15",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 7 เชียงใหม่",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมล้านนา",
        "RiverBasin": "ลุ่มน้ำสาละวิน, ลุ่มน้ำโขงเหนือ, ลุ่มน้ำปิง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 15",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 9 จังหวัดเชียงใหม่",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 1 เชียงใหม่",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 1 จังหวัดเชียงใหม่",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 1",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ เชียงใหม่",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 5",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 1 (เชียงใหม่)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 1",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 1",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 32",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาเชียงใหม่",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 5 (ลำปาง)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 3 เชียงใหม่"
    },
    {
        "ProvinceNo": "15",
        "ProvinceMOI_ID": "92",
        "ProvinceNameThai": "จังหวัดตรัง",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 12",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนล่าง",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "22",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอันดามัน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันตก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 9",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 9",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 12",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 15",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 6 (ตรัง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 5",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคใต้) จังหวัดนครศรีธรรมราช",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 12",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 13",
        "RegionFineArts": "สำนักศิลปากรที่ 11 สงขลา",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานตรัง",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 9",
        "RegionAdministrativeCourt": "ศาลปกครองสงขลา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 9",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 9",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 9",
        "RegionCGDOffice": "สำนักงานคลังเขต 9",
        "RegionRD": "สำนักงานสรรพากรภาค 12",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 10",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 14",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 6",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 6",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 12 ยะลา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 12",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 12 สงขลา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 18 ภูเก็ต",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 11",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 9",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 43",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 9",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรกันตัง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 9",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 8",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 6",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 5",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาตรัง กระบี่",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 6",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 17",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 15 สงขลา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอันดามัน",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน, ลุ่มน้ำทะเลสาบสงขลา, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 17 จังหวัดสงขลา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 12/1 ตรัง",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 12 จังหวัดสงขลา",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 5",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ ตรัง",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 4",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 12 (นครศรีธรรมราช)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 16",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 8",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 7",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 43",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาตรัง",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 5",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 9",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 9 (สงขลา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 1 สงขลา"
    },
    {
        "ProvinceNo": "16",
        "ProvinceMOI_ID": "23",
        "ProvinceNameThai": "จังหวัดตราด",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 3",
        "Region_SenatorFieldWork": "ภาคตะวันออก",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออก",
        "RegionID": "4",
        "RegionName": "ภาคตะวันออก",
        "ProvincialClusterID": "42",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออก 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออก",
        "RegionTMD": "ภาคตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคตะวันออก",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 2",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 2",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 6",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 13",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออก",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 9 (ระยอง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 1",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคกลาง) จังหวัดชลบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 2",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 17",
        "RegionFineArts": "สำนักศิลปากรที่ 5 ปราจีนบุรี",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานตราด",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 2",
        "RegionAdministrativeCourt": "ศาลปกครองระยอง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 2",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 2",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 9",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 6 ชลบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 6",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 6 ระยอง",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 17 จันทบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 2",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 19",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 2",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "ด่านศุลกากรคลองใหญ่",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 6",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 9",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 3",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาจันทบุรี ตราด",
        "Region_SSOProvincialOffice": "ภาคตะวันออก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 9",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 13",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 12 - 13 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 5 ระยอง",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวฝั่งทะเลตะวันออก",
        "RiverBasin": "ลุ่มน้ำโตนเลสาบ, ลุ่มน้ำชายฝั่งทะเลตะวันออก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 3 จังหวัดชลบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 6 ชลบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 6 จังหวัดชลบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออก",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 4",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดจันทบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคตะวันออก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 9 (ชลบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 9",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 6",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 1",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 12",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาตราด",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 2 (ชลบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "17",
        "ProvinceMOI_ID": "63",
        "ProvinceNameThai": "จังหวัดตาก",
        "Region_VaccineRollout_MOPH": "ภาคตะวันตก",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 8",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "63",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันตก",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 2",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 3",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 7 (กำแพงเพชร)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคเหนือ) จังหวัดพิษณุโลก",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 9",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 38",
        "RegionFineArts": "สำนักศิลปากรที่ 6 สุโขทัย",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานตาก",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองพิษณุโลก",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 6",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 7",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 2",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 10",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 17",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 2 พิษณุโลก",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 2",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 2 พิษณุโลก",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 8 กำแพงเพชร",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 8",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 2",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 310",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรแม่สอด",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 6",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 2",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 17",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 2 จังหวัดพิษณุโลก",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 11",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาตาก",
        "Region_SSOProvincialOffice": "ภาคตะวันตก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 17",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 5",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 4 - 5 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 6 พิษณุโลก",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวมรดกโลกด้านวัฒนธรรม",
        "RiverBasin": "ลุ่มน้ำสาละวิน, ลุ่มน้ำปิง, ลุ่มน้ำวัง, ลุ่มน้ำยม, ลุ่มน้ำแม่กลอง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 14 จังหวัดชัยนาท",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 2 พิษณุโลก",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 2 จังหวัดพิษณุโลก",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันตก",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคตะวันตก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 4 (ตาก)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 4",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 1",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 31",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาพิษณุโลก",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 6",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "18",
        "ProvinceMOI_ID": "26",
        "ProvinceNameThai": "จังหวัดนครนายก",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 2",
        "Region_SenatorFieldWork": "ภาคตะวันออก",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคกลาง",
        "RegionID": "4",
        "RegionName": "ภาคตะวันออก",
        "ProvincialClusterID": "42",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออก 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 2",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 2",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 4",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 7",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออก",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 3 (สระบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 2",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคกลาง) จังหวัดพระนครศรีอยุธยา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 7",
        "RegionFineArts": "สำนักศิลปากรที่ 3 พระนครศรีอยุธยา",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครนายก",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 2",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 2",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 1",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 9",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 4 สระบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 4",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 4 สระบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 3 ปราจีนบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 1",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 12",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 2",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "ด่านศุลกากรอรัญประเทศ",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 9",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 3",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาปราจีนบุรี นครนายก",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 9",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 12",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "ภาค 12 - 13 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 4 ฉะเชิงเทรา",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวผืนป่ามรดกโลกดงพญาเย็น - เขาใหญ่",
        "RiverBasin": "ลุ่มน้ำมูล, ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำบางปะกง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 4 จังหวัดนครนายก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 4 สระบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 4 จังหวัดสระบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 4",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 9 สาขาปราจีนบุรี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 9, สำนักงานชลประทานที่ 11",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 6",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 14",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาฉะเชิงเทรา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 10 (สมุทรปราการ)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "19",
        "ProvinceMOI_ID": "73",
        "ProvinceNameThai": "จังหวัดนครปฐม",
        "Region_VaccineRollout_MOPH": "กรุงเทพมหานครและปริมณฑล",
        "Region_RDPB": "ปริมณฑล",//"ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 4",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตนครหลวง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "12",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางปริมณฑล",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 7",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 7",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 5",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 5",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 8 (ราชบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 3",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคกลาง) จังหวัดนครปฐม",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 9",
        "RegionFineArts": "สำนักศิลปากรที่ 2 สุพรรณบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานราชบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 7",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 7",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 7",
        "RegionCGDOffice": "สำนักงานคลังเขต 7",
        "RegionRD": "สำนักงานสรรพากรภาค 6",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 12",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 3",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 2",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 5 ราชบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 5",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 5 ราชบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 1 ปทุมธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 3",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 10",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 11",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 7",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 7",
        "Region_CustomHouse": "N/A",
        "Region_CustomsBureau": "สำนักงานศุลกากรกรุงเทพ",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 10",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 2",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "กรุงเทพมหานครและปริมณฑล",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 16",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษานครปฐม",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 2",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 2 จังหวัดราชบุรี",
        "Region_MonkMahaNikai": "ภาค 14",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 2",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันตก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 1 นนทบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำท่าจีน, ลุ่มน้ำแม่กลอง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 2",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 15 จังหวัดเพชรบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 5 สมุทรสงคราม",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 5 จังหวัดราชบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 (ราชบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 13",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันตก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 7",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 16",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครปฐม",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 3",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 7",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 7 (ราชบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "20",
        "ProvinceMOI_ID": "48",
        "ProvinceNameThai": "จังหวัดนครพนม",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 7",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "52",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 8",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 9",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 10 (อุดรธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 7",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุดรธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 4",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 22",
        "RegionFineArts": "สำนักศิลปากรที่ 9 อุบลราชธานี",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครพนม",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองอุดรธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 4",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 5",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 11",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 8 อุดรธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 8",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 8 อุดรธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 7 สกลนคร",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 6",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 3",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 210",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรนครพนม",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 5",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 11",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 5 จังหวัดขอนแก่น",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 15",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษานครพนม",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 11",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 10",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 11",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 9 อุดรธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำโขง",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 11",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 8 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 8 อุดรธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 8 จังหวัดอุดรธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 6 สาขานครพนม",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 7",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 3",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 25",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครพนม",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 10",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "21",
        "ProvinceMOI_ID": "30",
        "ProvinceNameThai": "จังหวัดนครราชสีมา",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 5",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "54",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 3",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 3",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 9",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 11",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 5 (นครราชสีมา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 2",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคตะวันออกเฉียงเหนือ) จังหวัดนครราชสีมา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 3",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 31",
        "RegionFineArts": "สำนักศิลปากรที่ 10 นครราชสีมา",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครราชสีมา",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 3",
        "RegionAdministrativeCourt": "ศาลปกครองนครราชสีมา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 3",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 3",
        "RegionRD": "สำนักงานสรรพากรภาค 9",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 7",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 4",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 13",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 9 นครราชสีมา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 9",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 9 นครราชสีมา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 5 นครราชสีมา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 4",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 5",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 21",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 3",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 3",
        "Region_CustomHouse": "ด่านศุลกากรช่องจอม",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 3",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 13",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 6 จังหวัดนครราชสีมา",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 9",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษานครราชสีมา",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 13",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 11",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 13",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 11 นครราชสีมา",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมอีสานใต้",
        "RiverBasin": "ลุ่มน้ำชี, ลุ่มน้ำมูล, ลุ่มน้ำป่าสัก, ลุ่มน้ำบางปะกง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 13",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 5 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 9 นครราชสีมา",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 9 จังหวัดนครราชสีมา",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 2",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 7",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 8 (นครราชสีมา)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 8",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 5",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 23",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครราชสีมา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 3",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 3 (นครราชสีมา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "22",
        "ProvinceMOI_ID": "80",
        "ProvinceNameThai": "จังหวัดนครศรีธรรมราช",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 11",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนล่าง",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "21",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอ่าวไทย",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 8",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 8",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 11",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 14",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 6 (ตรัง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 4",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคใต้) จังหวัดนครศรีธรรมราช",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 11",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 12",
        "RegionFineArts": "สำนักศิลปากรที่ 12 นครศรีธรรมราช",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครศรีธรรมราช",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 8",
        "RegionAdministrativeCourt": "ศาลปกครองนครศรีธรรมราช",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 8",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 8",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 8",
        "RegionCGDOffice": "สำนักงานคลังเขต 8",
        "RegionRD": "สำนักงานสรรพากรภาค 11",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 9",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 14",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 5",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 5",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 11 นครศรีธรรมราช",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 11",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 11 สุราษฎร์ธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 11 สุราษฎร์ธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 10",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 8",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 41, มณฑลทหารบกที่ 43",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 8",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรนครศรีธรรมราช, ด่านศุลกากรสิชล",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 8",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 7",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 5",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 4",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษานครศรีธรรมราช",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 5",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 16",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 16 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 13 สุราษฎร์ธานี",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มน้ำทะเลสาบสงขลา",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน, ลุ่มน้ำทะเลสาบสงขลา, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 19 จังหวัดสุราษฎร์ธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 11 สุราษฎร์ธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 11 จังหวัดนครศรีธรรมราช",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 6",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ สงขลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 3",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 12 (นครศรีธรรมราช)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 15",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 8",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 5",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 43",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครศรีธรรมราช",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 4",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 8",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 9 (สงขลา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 1 สงขลา"
    },
    {
        "ProvinceNo": "23",
        "ProvinceMOI_ID": "60",
        "ProvinceNameThai": "จังหวัดนครสวรรค์",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 8",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "64",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 3",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 4",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคเหนือ) จังหวัดลพบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 9",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 42",
        "RegionFineArts": "สำนักศิลปากรที่ 4 ลพบุรี",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครสวรรค์",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองนครสวรรค์",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 6",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 7",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 3",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 11",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 18",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 3 นครสวรรค์",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 3",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 3 นครสวรรค์",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 8 กำแพงเพชร",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 7",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 12",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 31",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรแม่สอด",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 6",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 18",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 3 จังหวัดพิจิตร",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 18",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษานครสวรรค์",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 18",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 4",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 4 - 5 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 18",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำปิง, ลุ่มน้ำยม, ลุ่มน้ำน่าน, ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำสะแกกรัง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 18",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 14 จังหวัดชัยนาท",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 3 นครสวรรค์",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 3 จังหวัดนครสวรรค์",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 4 สาขานครสวรรค์",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 3, สำนักงานชลประทานที่ 10",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 35",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครสวรรค์",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 6",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "24",
        "ProvinceMOI_ID": "12",
        "ProvinceNameThai": "จังหวัดนนทบุรี",
        "Region_VaccineRollout_MOPH": "กรุงเทพมหานครและปริมณฑล",
        "Region_RDPB": "ปริมณฑล",//"ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 1",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตนครหลวง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "12",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางปริมณฑล",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 4",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 6",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปานครหลวง",
        "RegionWaterAuthorities": "N/A",
        "RegionElectricityAuthorities": "การไฟฟ้านครหลวง",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 3",
        "RegionFineArts": "สำนักศิลปากรที่ 2 สุพรรณบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานกรุงเทพมหานคร",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 1",
        "RegionCGDOffice": "สำนักงานคลังเขต 1",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 13",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 3",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 2",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 4 สระบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 4",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 4 สระบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 1 ปทุมธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 1",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 11",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 1",
        "Region_CustomHouse": "N/A",
        "Region_CustomsBureau": "สำนักงานศุลกากรกรุงเทพ",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 2",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "กรุงเทพมหานครและปริมณฑล",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 16",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษานนทบุรี",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 2",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 1",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 2",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคกลาง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 1 นนทบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำเจ้าพระยาตอนกลาง",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำท่าจีน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 2",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 1 จังหวัดปทุมธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 4 สระบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 4 จังหวัดสระบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "N/A",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 5 (สระบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 11",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 11",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานนทบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์นครหลวง 1",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 1 (พระนครศรีอยุธยา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "25",
        "ProvinceMOI_ID": "96",
        "ProvinceNameThai": "จังหวัดนราธิวาส",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 12",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนล่าง",
        "RegionID": "3",
        "RegionName": "ภาคใต้ชายแดน",
        "ProvincialClusterID": "31",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ชายแดน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 9",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 9",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 12",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 16",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 12 (สงขลา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 5",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคใต้) จังหวัดยะลา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 12",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 15",
        "RegionFineArts": "สำนักศิลปากรที่ 11 สงขลา",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนราธิวาส",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 9",
        "RegionAdministrativeCourt": "ศาลปกครองยะลา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 9",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 9",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 9",
        "RegionCGDOffice": "สำนักงานคลังเขต 9",
        "RegionRD": "สำนักงานสรรพากรภาค 12",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 10",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 15",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 6",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 7",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 12 ยะลา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 12",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 12 สงขลา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 12 สงขลา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 11",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 9",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 46",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 10",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 9",
        "Region_CustomHouse": "ด่านศุลกากรตากใบ, ด่านศุลกากรบูเก๊ะตา, ด่านศุลกากรสุไหงโก-ลก",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 9",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 8",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 7",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 11 จังหวัดสงชลา",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 6",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษานราธิวาส",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 7",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 18",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 7",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 15 สงขลา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวพหุวัฒนธรรมชายแดนภาคใต้",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนล่าง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 7",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 18 จังหวัดสงขลา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 12 สงขลา",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 12 จังหวัดสงขลา",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 5",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ ยะลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 5 (ศป.ข.ภาค 5)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 4",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 13 สาขานราธิวาส",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 17",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 8",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 9",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 41",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานราธิวาส",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 4",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 9",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 9 (สงขลา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 1 สงขลา"
    },
    {
        "ProvinceNo": "26",
        "ProvinceMOI_ID": "55",
        "ProvinceNameThai": "จังหวัดน่าน",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 9",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนบน)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนบน",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "62",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนบน 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 5",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 5",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 1",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 2",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 1 (ลำปาง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 9",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคเหนือ) จังหวัดพิษณุโลก",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 7",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 37",
        "RegionFineArts": "สำนักศิลปากรที่ 7 เชียงใหม่",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานน่าน",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 5",
        "RegionAdministrativeCourt": "ศาลปกครองเชียงใหม่",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 5",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 5",
        "RegionRD": "สำนักงานสรรพากรภาค 8",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 2",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 9",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 3",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 16",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 1 เชียงใหม่",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 1",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 1 เชียงใหม่",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 15 เชียงราย",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 9",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 2",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือบน",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 38",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 5",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 5",
        "Region_CustomHouse": "ด่านศุลกากรทุ่งช้าง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 7",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 1",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 16",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 1 จังหวัดเชียงใหม่",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 17",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาน่าน",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 16",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 6",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 6 - 7 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 16",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 8 พะเยา",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวเมืองเก่ามีชีวิต",
        "RiverBasin": "ลุ่มน้ำยม, ลุ่มน้ำน่าน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 16",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 12 จังหวัดพิษณุโลก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 1/1 เชียงราย",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 1 จังหวัดเชียงใหม่",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 1",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 5",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 3 สาขาแพร่",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 2",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 9",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 34",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาแพร่",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 5 (ลำปาง)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 3 เชียงใหม่"
    },
    {
        "ProvinceNo": "27",
        "ProvinceMOI_ID": "38",
        "ProvinceNameThai": "จังหวัดบึงกาฬ",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 6",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "51",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 8",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 9",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 10 (อุดรธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 7",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุดรธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 5",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 21",
        "RegionFineArts": "สำนักศิลปากรที่ 8 ขอนแก่น",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานอุดรธานี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองอุดรธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 6",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 6",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 10",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 8 อุดรธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 8",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 8 อุดรธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 7 สกลนคร",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 6",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 3",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 29",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรบึงกาฬ",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 5",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 10",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 4 จังหวัดอุดรธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 7",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาบึงกาฬ",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 10",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 8",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 9 อุดรธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำโขง",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 7 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 8 อุดรธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 8 จังหวัดอุดรธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 6 (อุดรธานี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 5",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 3",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 25",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาหนองคาย",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "28",
        "ProvinceMOI_ID": "31",
        "ProvinceNameThai": "จังหวัดบุรีรัมย์",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 5",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "54",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 3",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 3",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 9",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 11",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 5 (นครราชสีมา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 8",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคตะวันออกเฉียงเหนือ) จังหวัดนครราชสีมา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 3",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 32",
        "RegionFineArts": "สำนักศิลปากรที่ 10 นครราชสีมา",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานบุรีรัมย์",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 3",
        "RegionAdministrativeCourt": "ศาลปกครองนครราชสีมา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 3",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 3",
        "RegionRD": "สำนักงานสรรพากรภาค 9",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 7",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 4",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 13",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 9 นครราชสีมา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 9",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 9 นครราชสีมา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 5 นครราชสีมา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 4",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 5",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 26",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 3",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 3",
        "Region_CustomHouse": "ด่านศุลกากรช่องจอม",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 3",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 13",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 6 จังหวัดนครราชสีมา",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 9",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาบุรีรัมย์",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 13",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 11",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 13",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 11 นครราชสีมา",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมอีสานใต้",
        "RiverBasin": "ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 13",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 5 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 9 นครราชสีมา",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 9 จังหวัดนครราชสีมา",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 2",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 7",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 8 (นครราชสีมา)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 8",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 5",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 23",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครราชสีมา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 3",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 3 (นครราชสีมา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "29",
        "ProvinceMOI_ID": "13",
        "ProvinceNameThai": "จังหวัดปทุมธานี",
        "Region_VaccineRollout_MOPH": "กรุงเทพมหานครและปริมณฑล",
        "Region_RDPB": "ปริมณฑล",//"ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 1",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตนครหลวง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "12",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางปริมณฑล",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 4",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 6",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 2",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคกลาง) จังหวัดพระนครศรีอยุธยา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 4",
        "RegionFineArts": "สำนักศิลปากรที่ 2 สุพรรณบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานกรุงเทพมหานคร",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 1",
        "RegionCGDOffice": "สำนักงานคลังเขต 1",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 13",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 3",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 2",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 4 สระบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 4",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 4 สระบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 1 ปทุมธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 1",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 11",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 1",
        "Region_CustomHouse": "N/A",
        "Region_CustomsBureau": "สำนักงานศุลกากรกรุงเทพ",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 2",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "กรุงเทพมหานครและปริมณฑล",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 16",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาปทุมธานี",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 2",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 1",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 2",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคกลาง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 1 นนทบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำเจ้าพระยาตอนกลาง",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำบางปะกง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 2",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 1 จังหวัดปทุมธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 4 สระบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 4 จังหวัดสระบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "N/A",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 5 (สระบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 11",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 11",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานนทบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์นครหลวง 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 1 (พระนครศรีอยุธยา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "30",
        "ProvinceMOI_ID": "77",
        "ProvinceNameThai": "จังหวัดประจวบคีรีขันธ์",
        "Region_VaccineRollout_MOPH": "ภาคตะวันตก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 4",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันตก",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "14",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันตก",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 7",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 7",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 5",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 8",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 8 (ราชบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 3",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคใต้) จังหวัดเพชรบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 10",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 10",
        "RegionFineArts": "สำนักศิลปากรที่ 1 ราชบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานประจวบคีรีขันธ์",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 7",
        "RegionAdministrativeCourt": "ศาลปกครองเพชรบุรี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 7",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 7",
        "RegionCGDOffice": "สำนักงานคลังเขต 7",
        "RegionRD": "สำนักงานสรรพากรภาค 6",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 12",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 12",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 4",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 5 ราชบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 5",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 5 ราชบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 4 ประจวบคีรีขันธ์",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 3",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 10",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 15",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 7",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 7",
        "Region_CustomHouse": "ด่านศุลกากรประจวบคีรีขันธ์",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 10",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 7",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 4",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันตก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 14",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาประจวบคีรีขันธ์",
        "Region_SSOProvincialOffice": "ภาคตะวันตก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 4",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 2 จังหวัดราชบุรี",
        "Region_MonkMahaNikai": "ภาค 15",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 4",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันตก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 3 เพชรบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวฝั่งทะเลตะวันตก",
        "RiverBasin": "ลุ่มน้ำเพชรบุรี - ประจวบคีรีขันธ์, ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 4",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 16 จังหวัดเพชรบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 5 สมุทรสงคราม",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 5 จังหวัดราชบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันตก",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคตะวันตก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 3",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 สาขาเพชรบุรี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 14",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันตก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 7",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 3",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 45",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาประจวบคีรีขันธ์",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 3",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 7",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 7 (ราชบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "31",
        "ProvinceMOI_ID": "25",
        "ProvinceNameThai": "จังหวัดปราจีนบุรี",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 3",
        "Region_SenatorFieldWork": "ภาคตะวันออก",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออก",
        "RegionID": "4",
        "RegionName": "ภาคตะวันออก",
        "ProvincialClusterID": "42",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออก 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออก",
        "RegionTMD": "ภาคตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคตะวันออก",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 2",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 2",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 6",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 7",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออก",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 3 (สระบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 1",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคกลาง) จังหวัดพระนครศรีอยุธยา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 2",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 7",
        "RegionFineArts": "สำนักศิลปากรที่ 5 ปราจีนบุรี",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครนายก",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 2",
        "RegionAdministrativeCourt": "ศาลปกครองระยอง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 2",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 1",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 9",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 6 ชลบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 6",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 6 ระยอง",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 3 ปราจีนบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 2",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 12",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 2",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "ด่านศุลกากรอรัญประเทศ",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 6",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 9",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 3",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาปราจีนบุรี นครนายก",
        "Region_SSOProvincialOffice": "ภาคตะวันออก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 9",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 12",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "ภาค 12 - 13 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 4 ฉะเชิงเทรา",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวผืนป่ามรดกโลกดงพญาเย็น - เขาใหญ่",
        "RiverBasin": "ลุ่มน้ำมูล, ลุ่มน้ำบางปะกง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 4 จังหวัดนครนายก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 6 ชลบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 6 จังหวัดชลบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออก",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 4",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 3",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดจันทบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคตะวันออก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 9 สาขาปราจีนบุรี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 9",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 6",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 14",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาฉะเชิงเทรา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 2 (ชลบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "32",
        "ProvinceMOI_ID": "94",
        "ProvinceNameThai": "จังหวัดปัตตานี",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 12",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนล่าง",
        "RegionID": "3",
        "RegionName": "ภาคใต้ชายแดน",
        "ProvincialClusterID": "31",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ชายแดน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 9",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 9",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 12",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 16",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 12 (สงขลา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 5",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคใต้) จังหวัดยะลา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 12",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 15",
        "RegionFineArts": "สำนักศิลปากรที่ 11 สงขลา",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนราธิวาส",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 9",
        "RegionAdministrativeCourt": "ศาลปกครองยะลา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 9",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 9",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 9",
        "RegionCGDOffice": "สำนักงานคลังเขต 9",
        "RegionRD": "สำนักงานสรรพากรภาค 12",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 10",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 15",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 6",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 7",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 12 ยะลา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 12",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 12 สงขลา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 12 สงขลา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 11",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 9",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 46",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 10",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 9",
        "Region_CustomHouse": "ด่านศุลกากรปัตตานี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 9",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 8",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 7",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 11 จังหวัดสงชลา",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 6",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาปัตตานี",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 7",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 18",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 7",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 15 สงขลา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวพหุวัฒนธรรมชายแดนภาคใต้",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนล่าง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 7",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 18 จังหวัดสงขลา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 12 สงขลา",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 12 จังหวัดสงขลา",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 5",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ ยะลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 5 (ศป.ข.ภาค 5)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 4",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 13 (สงขลา)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 17",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 8",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 9",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 41",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาปัตตานี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 4",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 9",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 9 (สงขลา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 1 สงขลา"
    },
    {
        "ProvinceNo": "33",
        "ProvinceMOI_ID": "14",
        "ProvinceNameThai": "จังหวัดพระนครศรีอยุธยา",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 1",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคกลาง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "11",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนบน",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 4",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 6",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 2",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคกลาง) จังหวัดพระนครศรีอยุธยา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 3",
        "RegionFineArts": "สำนักศิลปากรที่ 3 พระนครศรีอยุธยา",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานพระนครศรีอยุธยา",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 1",
        "RegionCGDOffice": "สำนักงานคลังเขต 1",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 13",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 1",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 1",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 4 สระบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 4",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 4 สระบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 2 สุพรรณบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 1",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 18",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 1",
        "Region_CustomHouse": "N/A",
        "Region_CustomsBureau": "สำนักงานศุลกากรกรุงเทพ",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 1",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "ภาคกลาง",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 12",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพระนครศรีอยุธยา",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 1",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 2",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคกลาง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำเจ้าพระยาตอนกลาง",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำป่าสัก, ลุ่มน้ำท่าจีน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 2 จังหวัดปทุมธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 4 สระบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 4 จังหวัดสระบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 5 (สระบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 10, สำนักงานชลประทานที่ 11, สำนักงานชลประทานที่ 12",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 15",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาอยุธยา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 1",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 1 (พระนครศรีอยุธยา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "34",
        "ProvinceMOI_ID": "56",
        "ProvinceNameThai": "จังหวัดพะเยา",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 10",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนบน)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนบน",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "62",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนบน 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 5",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 5",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 1",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 2",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 1 (ลำปาง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 9",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคเหนือ) จังหวัดเชียงใหม่",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 7",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 36",
        "RegionFineArts": "สำนักศิลปากรที่ 7 เชียงใหม่",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานเชียงราย",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 5",
        "RegionAdministrativeCourt": "ศาลปกครองเชียงใหม่",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 5",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 5",
        "RegionRD": "สำนักงานสรรพากรภาค 8",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 1",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 9",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 3",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 16",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 1 เชียงใหม่",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 1",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 1 เชียงใหม่",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 15 เชียงราย",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 9",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 1",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือบน",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 34",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 5",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 5",
        "Region_CustomHouse": "ด่านศุลกากรเชียงของ, ด่านศุลกากรแม่สาย",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 7",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 1",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 16",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 1 จังหวัดเชียงใหม่",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 17",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพะเยา",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 16",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 6",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 6 - 7 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 16",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 8 พะเยา",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมล้านนา, เขตพัฒนาการท่องเที่ยวเมืองเก่ามีชีวิต",
        "RiverBasin": "ลุ่มน้ำโขงเหนือ, ลุ่มน้ำยม",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 16",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 10 จังหวัดลำปาง",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 1/1 เชียงราย",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 1 จังหวัดเชียงใหม่",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 1",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 5",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 2 (เชียงราย)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 2",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 1",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 34",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาเชียงราย",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 5 (ลำปาง)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 3 เชียงใหม่"
    },
    {
        "ProvinceNo": "35",
        "ProvinceMOI_ID": "82",
        "ProvinceNameThai": "จังหวัดพังงา",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 11",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนบน",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "22",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอันดามัน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันตก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 8",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 8",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 11",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 15",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 6 (ตรัง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 4",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคใต้) จังหวัดนครศรีธรรมราช",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 11",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 14",
        "RegionFineArts": "สำนักศิลปากรที่ 12 นครศรีธรรมราช",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานพังงา",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 8",
        "RegionAdministrativeCourt": "ศาลปกครองภูเก็ต",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 8",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 8",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 8",
        "RegionCGDOffice": "สำนักงานคลังเขต 8",
        "RegionRD": "สำนักงานสรรพากรภาค 11",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 9",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 13",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 5",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 6",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 11 นครศรีธรรมราช",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 11",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 11 สุราษฎร์ธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 18 ภูเก็ต",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 10",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 8",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 45",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 8",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรภูเก็ต",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 8",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 7",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 6",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 5",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพังงา ภูเก็ต ระนอง",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 6",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 17",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 14 พังงา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอันดามัน",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 20 จังหวัดสุราษฎร์ธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 11/1 ภูเก็ต",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 11 จังหวัดนครศรีธรรมราช",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 6",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ ตรัง",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 3",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 12 สาขากระบี่",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 15",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 10",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 6",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 42",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาพังงา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 5",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 8",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 8 (สุราษฎร์ธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 4 ภูเก็ต"
    },
    {
        "ProvinceNo": "36",
        "ProvinceMOI_ID": "93",
        "ProvinceNameThai": "จังหวัดพัทลุง",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 12",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนล่าง",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "21",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอ่าวไทย",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 9",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 9",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 12",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 14",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 12 (สงขลา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 5",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคใต้) จังหวัดยะลา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 12",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 12",
        "RegionFineArts": "สำนักศิลปากรที่ 11 สงขลา",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครศรีธรรมราช",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 9",
        "RegionAdministrativeCourt": "ศาลปกครองสงขลา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 9",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 9",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 9",
        "RegionCGDOffice": "สำนักงานคลังเขต 8",
        "RegionRD": "สำนักงานสรรพากรภาค 12",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 10",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 14",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 6",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 5",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 12 ยะลา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 12",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 12 สงขลา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 11 สุราษฎร์ธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 11",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 9",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 42",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 9",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรสงขลา",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 9",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 8",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 5",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 4",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพัทลุง",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 5",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 18",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 15 สงขลา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มน้ำทะเลสาบสงขลา",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน, ลุ่มน้ำทะเลสาบสงขลา, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 17 จังหวัดสงขลา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 12/1 ตรัง",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 12 จังหวัดสงขลา",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 5",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ สงขลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 4",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 12 (นครศรีธรรมราช)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 16",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 8",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 5",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 43",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสงขลา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 4",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 9",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 9 (สงขลา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 1 สงขลา"
    },
    {
        "ProvinceNo": "37",
        "ProvinceMOI_ID": "66",
        "ProvinceNameThai": "จังหวัดพิจิตร",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 9",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "64",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 3",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 4",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 7 (กำแพงเพชร)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคเหนือ) จังหวัดพิษณุโลก",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 8",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 41",
        "RegionFineArts": "สำนักศิลปากรที่ 6 สุโขทัย",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครสวรรค์",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองพิษณุโลก",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 6",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 7",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 3",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 11",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 18",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 3 นครสวรรค์",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 3",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 3 นครสวรรค์",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 8 กำแพงเพชร",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 7",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 12",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 36",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรทุ่งช้าง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 6",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 2",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 18",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 3 จังหวัดพิจิตร",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 18",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพิจิตร",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 18",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 4",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 4 - 5 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 18",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 6 พิษณุโลก",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำยม, ลุ่มน้ำน่าน, ลุ่มน้ำเจ้าพระยา",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 18",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 11 จังหวัดพิษณุโลก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 3 นครสวรรค์",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 3 จังหวัดนครสวรรค์",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 4 สาขานครสวรรค์",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 3",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 9",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 35",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครสวรรค์",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 6",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "38",
        "ProvinceMOI_ID": "65",
        "ProvinceNameThai": "จังหวัดพิษณุโลก",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 9",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "63",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 2",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 3",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 7 (กำแพงเพชร)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคเหนือ) จังหวัดพิษณุโลก",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 8",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 39",
        "RegionFineArts": "สำนักศิลปากรที่ 6 สุโขทัย",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานพิษณุโลก",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองพิษณุโลก",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 6",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 7",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 3",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 10",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 17",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 2 พิษณุโลก",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 2",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 2 พิษณุโลก",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 9 พิษณุโลก",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 8",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 2",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 39",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรทุ่งช้าง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 6",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 2",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 17",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 2 จังหวัดพิษณุโลก",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 11",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพิษณุโลก อุตรดิตถ์",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 17",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 5",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 4 - 5 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 6 พิษณุโลก",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวมรดกโลกด้านวัฒนธรรม",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำยม, ลุ่มน้ำน่าน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 11 จังหวัดพิษณุโลก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 2 พิษณุโลก",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 2 จังหวัดพิษณุโลก",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 4 สาขาพิษณุโลก",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 3",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 9",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 33",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาพิษณุโลก",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 6",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "39",
        "ProvinceMOI_ID": "76",
        "ProvinceNameThai": "จังหวัดเพชรบุรี",
        "Region_VaccineRollout_MOPH": "ภาคตะวันตก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 4",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันตก",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "14",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันตก",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 7",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 7",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 5",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 8",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 8 (ราชบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 3",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคใต้) จังหวัดเพชรบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 10",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 10",
        "RegionFineArts": "สำนักศิลปากรที่ 1 ราชบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานเพชรบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 7",
        "RegionAdministrativeCourt": "ศาลปกครองเพชรบุรี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 7",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 7",
        "RegionCGDOffice": "สำนักงานคลังเขต 7",
        "RegionRD": "สำนักงานสรรพากรภาค 6",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 12",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 12",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 4",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 5 ราชบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 5",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 5 ราชบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 4 ประจวบคีรีขันธ์",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 3",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 10",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 15",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 7",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 7",
        "Region_CustomHouse": "ด่านศุลกากรแม่กลอง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 10",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 4",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันตก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 14",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาเพชรบุรี",
        "Region_SSOProvincialOffice": "ภาคตะวันตก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 4",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 2 จังหวัดราชบุรี",
        "Region_MonkMahaNikai": "ภาค 15",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 4",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันตก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 3 เพชรบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวฝั่งทะเลตะวันตก",
        "RiverBasin": "ลุ่มน้ำเพชรบุรี - ประจวบคีรีขันธ์",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 4",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 16 จังหวัดเพชรบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 5 สมุทรสงคราม",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 5 จังหวัดราชบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันตก",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคตะวันตก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 สาขาเพชรบุรี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 13, สำนักงานชลประทานที่ 14",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันตก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 7",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 3",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 16",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาเพชรบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 3",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 7",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 7 (ราชบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "40",
        "ProvinceMOI_ID": "67",
        "ProvinceNameThai": "จังหวัดเพชรบูรณ์",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 9",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "63",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 2",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 3",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 3 (สระบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคเหนือ) จังหวัดลพบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 8",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 40",
        "RegionFineArts": "สำนักศิลปากรที่ 4 ลพบุรี",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานพิษณุโลก",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองนครสวรรค์",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 6",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 7",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 3",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 10",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 17",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 2 พิษณุโลก",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 2",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 2 พิษณุโลก",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 9 พิษณุโลก",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 8",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 12",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 36",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรทุ่งช้าง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 6",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 2",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 17",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 2 จังหวัดพิษณุโลก",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 11",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาเพชรบูรณ์",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 17",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 4",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 4 - 5 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 6 พิษณุโลก",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี, ลุ่มน้ำน่าน, ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำป่าสัก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 11 จังหวัดพิษณุโลก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 2 พิษณุโลก",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 2 จังหวัดพิษณุโลก",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 4 สาขาพิษณุโลก",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 10",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 33",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาพิษณุโลก",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 6",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "41",
        "ProvinceMOI_ID": "54",
        "ProvinceNameThai": "จังหวัดแพร่",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 9",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนบน)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนบน",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "62",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนบน 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 5",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 5",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 1",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 2",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 1 (ลำปาง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 9",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคเหนือ) จังหวัดพิษณุโลก",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 7",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 37",
        "RegionFineArts": "สำนักศิลปากรที่ 7 เชียงใหม่",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานแพร่",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 5",
        "RegionAdministrativeCourt": "ศาลปกครองเชียงใหม่",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 5",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 5",
        "RegionRD": "สำนักงานสรรพากรภาค 8",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 2",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 9",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 3",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 16",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 1 เชียงใหม่",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 1",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 1 เชียงใหม่",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 15 เชียงราย",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 9",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 2",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือบน",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 35",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 5",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 5",
        "Region_CustomHouse": "ด่านศุลกากรท่าอากาศยานเชียงใหม่",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 7",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 1",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 16",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 1 จังหวัดเชียงใหม่",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 17",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาแพร่",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 16",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 6",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 6 - 7 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 16",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 8 พะเยา",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวเมืองเก่ามีชีวิต",
        "RiverBasin": "ลุ่มน้ำยม, ลุ่มน้ำน่าน, ลุ่มน้ำวัง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 16",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 12 จังหวัดพิษณุโลก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 1/1 เชียงราย",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 1 จังหวัดเชียงใหม่",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 1",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 5",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 3 สาขาแพร่",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 4",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 9",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 31",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาแพร่",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 5 (ลำปาง)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 3 เชียงใหม่"
    },
    {
        "ProvinceNo": "42",
        "ProvinceMOI_ID": "83",
        "ProvinceNameThai": "จังหวัดภูเก็ต",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 11",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนบน",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "22",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอันดามัน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันตก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 8",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 8",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 11",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 15",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 6 (ตรัง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 4",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคใต้) จังหวัดนครศรีธรรมราช",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 11",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 14",
        "RegionFineArts": "สำนักศิลปากรที่ 12 นครศรีธรรมราช",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานภูเก็ต",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 8",
        "RegionAdministrativeCourt": "ศาลปกครองภูเก็ต",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 8",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 8",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 8",
        "RegionCGDOffice": "สำนักงานคลังเขต 9",
        "RegionRD": "สำนักงานสรรพากรภาค 11",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 9",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 13",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 5",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 6",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 11 นครศรีธรรมราช",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 11",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 11 สุราษฎร์ธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 18 ภูเก็ต",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 10",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 8",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 41",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 8",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรท่าอากาศยานภูเก็ต, ด่านศุลกากรภูเก็ต",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 8",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 7",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 6",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 5",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพังงา ภูเก็ต ระนอง",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 6",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 17",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 14 พังงา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอันดามัน",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 20 จังหวัดสุราษฎร์ธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 11/1 ภูเก็ต",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 11 จังหวัดนครศรีธรรมราช",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 6",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ ตรัง",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 3",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 12 สาขากระบี่",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 15",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 10",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 10",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 42",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาภูเก็ต",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 5",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 8",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 8 (สุราษฎร์ธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 4 ภูเก็ต"
    },
    {
        "ProvinceNo": "43",
        "ProvinceMOI_ID": "44",
        "ProvinceNameThai": "จังหวัดมหาสารคาม",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 5",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "53",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนกลาง",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 7",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 10",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 4 (ขอนแก่น)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 6",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุบลราชธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 5",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 26",
        "RegionFineArts": "สำนักศิลปากรที่ 10 นครราชสีมา",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานขอนแก่น",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองขอนแก่น",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 5",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 7",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 12",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 7 ขอนแก่น",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 7",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 7 ขอนแก่น",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 6 ขอนแก่น",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 5",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 4",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 26",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรมุกดาหาร",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 3",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 12",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 5 จังหวัดขอนแก่น",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 8",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษามหาสารคาม",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 12",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 9",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 12",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 10 ขอนแก่น",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำชี, ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 12",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 8 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 7 ขอนแก่น",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 7 จังหวัดขอนแก่น",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 (ขอนแก่น)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 6",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 4",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 21",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาขอนแก่น",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "44",
        "ProvinceMOI_ID": "49",
        "ProvinceNameThai": "จังหวัดมุกดาหาร",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 7",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "52",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 10",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 12",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 10 (อุดรธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 8",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุบลราชธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 4",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 22",
        "RegionFineArts": "สำนักศิลปากรที่ 9 อุบลราชธานี",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครพนม",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองขอนแก่น",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 8",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 5",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 11",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 10 อุบลราชธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 10",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 10 อุบลราชธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 7 สกลนคร",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 6",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 11",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 210",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรมุกดาหาร",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 4",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 11",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 5 จังหวัดขอนแก่น",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 15",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษามุกดาหาร",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 11",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 10",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 11",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 12 อุบลราชธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำโขง",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี, ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 11",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 8 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 10 อุบลราชธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 10 จังหวัดอุบลราชธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 (ขอนแก่น)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 7",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 11",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 25",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครพนม",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 10",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "45",
        "ProvinceMOI_ID": "58",
        "ProvinceNameThai": "จังหวัดแม่ฮ่องสอน",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 10",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนบน)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนบน",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "61",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 5",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 5",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 1",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 1",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 1 (ลำปาง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 9",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคเหนือ) จังหวัดเชียงใหม่",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 6",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 34",
        "RegionFineArts": "สำนักศิลปากรที่ 7 เชียงใหม่",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานแม่ฮ่องสอน",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 5",
        "RegionAdministrativeCourt": "ศาลปกครองเชียงใหม่",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 5",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 5",
        "RegionRD": "สำนักงานสรรพากรภาค 8",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 1",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 8",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 3",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 15",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 1 เชียงใหม่",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 1",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 1 เชียงใหม่",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 10 ลำปาง",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 9",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 1",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือบน",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 33",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 5",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 5",
        "Region_CustomHouse": "ด่านศุลกากรแม่สะเรียง, ด่านศุลกากรแม่ฮ่องสอน",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 7",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 1",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 15",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 1 จังหวัดเชียงใหม่",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 10",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาแม่ฮ่องสอน",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 15",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 7",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 6 - 7 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 15",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 7 เชียงใหม่",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำสาละวิน, ลุ่มน้ำปิง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 15",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 9 จังหวัดเชียงใหม่",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 1 เชียงใหม่",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 1 จังหวัดเชียงใหม่",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 1",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ เชียงใหม่",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 5",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 1 สาขาแม่ฮ่องสอน",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 1",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 1",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 32",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาเชียงใหม่",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 5 (ลำปาง)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 3 เชียงใหม่"
    },
    {
        "ProvinceNo": "46",
        "ProvinceMOI_ID": "35",
        "ProvinceNameThai": "จังหวัดยโสธร",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 7",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "55",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 3",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 3",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 10",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 12",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 11 (อุบลราชธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 8",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุบลราชธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 4",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 28",
        "RegionFineArts": "สำนักศิลปากรที่ 9 อุบลราชธานี",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานอุบลราชธานี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 3",
        "RegionAdministrativeCourt": "ศาลปกครองอุบลราชธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 3",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 3",
        "RegionRD": "สำนักงานสรรพากรภาค 9",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 4",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 5",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 14",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 10 อุบลราชธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 10",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 10 อุบลราชธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 13 อุบลราชธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 4",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 11",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 27",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 3",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 3",
        "Region_CustomHouse": "ด่านศุลกากรช่องเม็ก",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 4",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 14",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 7 จังหวัดอุบลราชธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 2",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาศรีสะเกษ ยโสธร",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 14",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 10",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 14",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 12 อุบลราชธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี, ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 14",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 6 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 10 อุบลราชธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 10 จังหวัดอุบลราชธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 2",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 7",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 สาขาอุบลราชธานี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 7",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 11",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 22",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาอุบลราชธานี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 10",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 3 (นครราชสีมา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "47",
        "ProvinceMOI_ID": "95",
        "ProvinceNameThai": "จังหวัดยะลา",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 12",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนล่าง",
        "RegionID": "3",
        "RegionName": "ภาคใต้ชายแดน",
        "ProvincialClusterID": "31",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ชายแดน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 9",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 9",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 12",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 16",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 12 (สงขลา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 5",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคใต้) จังหวัดยะลา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 12",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 15",
        "RegionFineArts": "สำนักศิลปากรที่ 11 สงขลา",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนราธิวาส",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 9",
        "RegionAdministrativeCourt": "ศาลปกครองยะลา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 9",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 9",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 9",
        "RegionCGDOffice": "สำนักงานคลังเขต 9",
        "RegionRD": "สำนักงานสรรพากรภาค 12",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 10",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 15",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 6",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 7",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 12 ยะลา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 12",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 12 สงขลา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 12 สงขลา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 11",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 9",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 46",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 10",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 9",
        "Region_CustomHouse": "ด่านศุลกากรเบตง, ด่านศุลกากรปัตตานี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 9",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 8",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 7",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 11 จังหวัดสงชลา",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 6",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษายะลา",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 7",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 18",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 7",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 15 สงขลา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวพหุวัฒนธรรมชายแดนภาคใต้",
        "RiverBasin": "ลุ่มน้ำทะเลสาบสงขลา, ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนล่าง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 7",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 18 จังหวัดสงขลา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 12 สงขลา",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 12 จังหวัดสงขลา",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 5",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ ยะลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 5 (ศป.ข.ภาค 5)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 4",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 13 สาขานราธิวาส",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 17",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 8",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 41",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาปัตตานี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 4",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 9",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 9 (สงขลา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 1 สงขลา"
    },
    {
        "ProvinceNo": "48",
        "ProvinceMOI_ID": "45",
        "ProvinceNameThai": "จังหวัดร้อยเอ็ด",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 7",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "53",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนกลาง",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 7",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 10",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 11 (อุบลราชธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 6",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุบลราชธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 4",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 27",
        "RegionFineArts": "สำนักศิลปากรที่ 9 อุบลราชธานี",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานขอนแก่น",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองอุบลราชธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 4",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 7",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 12",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 7 ขอนแก่น",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 7",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 7 ขอนแก่น",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 6 ขอนแก่น",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 5",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 4",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 27",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรช่องเม็ก",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 4",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 12",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 5 จังหวัดขอนแก่น",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 8",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาร้อยเอ็ด",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 12",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 9",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 12",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 10 ขอนแก่น",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี, ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 12",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 6 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 7 ขอนแก่น",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 7 จังหวัดขอนแก่น",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 (ขอนแก่น)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 6",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 4",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 21",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาขอนแก่น",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 3",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "49",
        "ProvinceMOI_ID": "85",
        "ProvinceNameThai": "จังหวัดระนอง",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 11",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนบน",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "22",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอันดามัน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันตก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 8",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 8",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 11",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 15",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 6 (ตรัง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 4",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคใต้) จังหวัดเพชรบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 11",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 14",
        "RegionFineArts": "สำนักศิลปากรที่ 12 นครศรีธรรมราช",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานชุมพร",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 8",
        "RegionAdministrativeCourt": "ศาลปกครองภูเก็ต",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 8",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 8",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 8",
        "RegionCGDOffice": "สำนักงานคลังเขต 8",
        "RegionRD": "สำนักงานสรรพากรภาค 11",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 9",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 13",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 5",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 6",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 11 นครศรีธรรมราช",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 11",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 11 สุราษฎร์ธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 18 ภูเก็ต",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 10",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 8",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 44",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 8",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรระนอง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 8",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 7",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 6",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 5",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพังงา ภูเก็ต ระนอง",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 6",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 17",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 14 พังงา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวฝั่งทะเลตะวันตก",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 20 จังหวัดสุราษฎร์ธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 11 สุราษฎร์ธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 11 จังหวัดนครศรีธรรมราช",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 6",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ ตรัง",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 3",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 11 (สุราษฎร์ธานี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 14",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 10",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 6",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 44",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาระนอง",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 5",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 8",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 8 (สุราษฎร์ธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 4 ภูเก็ต"
    },
    {
        "ProvinceNo": "50",
        "ProvinceMOI_ID": "21",
        "ProvinceNameThai": "จังหวัดระยอง",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 3",
        "Region_SenatorFieldWork": "ภาคตะวันออก",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออก",
        "RegionID": "4",
        "RegionName": "ภาคตะวันออก",
        "ProvincialClusterID": "41",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออก 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออก",
        "RegionTMD": "ภาคตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคตะวันออก",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 2",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 2",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 6",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 13",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออก",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 9 (ระยอง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 1",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคกลาง) จังหวัดชลบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 2",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 18",
        "RegionFineArts": "สำนักศิลปากรที่ 5 ปราจีนบุรี",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานระยอง",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 2",
        "RegionAdministrativeCourt": "ศาลปกครองระยอง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 2",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 2",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 8",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 6 ชลบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 6",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 6 ระยอง",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 17 จันทบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 2",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 14",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 2",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "ด่านศุลกากรมาบตาพุด",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 6",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 8",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 1",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาชลบุรี ระยอง",
        "Region_SSOProvincialOffice": "ภาคตะวันออก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 8",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 13",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 12 - 13 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 8",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 5 ระยอง",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวฝั่งทะเลตะวันออก",
        "RiverBasin": "ลุ่มน้ำชายฝั่งทะเลตะวันออก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 8",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 3 จังหวัดชลบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 6 ชลบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 6 จังหวัดชลบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออก",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 4",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 3",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดจันทบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคตะวันออก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 9 (ชลบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 9",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 6",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 1",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 12",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาระยอง",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 2 (ชลบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "51",
        "ProvinceMOI_ID": "70",
        "ProvinceNameThai": "จังหวัดราชบุรี",
        "Region_VaccineRollout_MOPH": "ภาคตะวันตก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 4",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันตก",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "13",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันตก",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 7",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 7",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 5",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 8",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 8 (ราชบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 3",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคใต้) จังหวัดเพชรบุรี, การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคกลาง) จังหวัดนครปฐม",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 10",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 8",
        "RegionFineArts": "สำนักศิลปากรที่ 1 ราชบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานราชบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 7",
        "RegionAdministrativeCourt": "ศาลปกครองเพชรบุรี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 7",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 7",
        "RegionCGDOffice": "สำนักงานคลังเขต 7",
        "RegionRD": "สำนักงานสรรพากรภาค 6",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 12",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 12",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 3",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 5 ราชบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 5",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 5 ราชบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 4 ประจวบคีรีขันธ์",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 3",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 10",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 16",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 7",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 7",
        "Region_CustomHouse": "ด่านศุลกากรแม่กลอง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 10",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 3",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันตก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 13",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาราชบุรี",
        "Region_SSOProvincialOffice": "ภาคตะวันตก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 3",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 2 จังหวัดราชบุรี",
        "Region_MonkMahaNikai": "ภาค 15",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 3",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันตก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 3 เพชรบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำท่าจีน, ลุ่มน้ำแม่กลอง, ลุ่มน้ำเพชรบุรี - ประจวบคีรีขันธ์",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 3",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 15 จังหวัดเพชรบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 5 สมุทรสงคราม",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 5 จังหวัดราชบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันตก",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคตะวันตก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 (ราชบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 13",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันตก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 7",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 16",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครปฐม",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 3",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 7",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 7 (ราชบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "52",
        "ProvinceMOI_ID": "16",
        "ProvinceNameThai": "จังหวัดลพบุรี",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 2",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคกลาง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "11",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนบน",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 4",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 7",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 3 (สระบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 2",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคเหนือ) จังหวัดลพบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 5",
        "RegionFineArts": "สำนักศิลปากรที่ 4 ลพบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานลพบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 1",
        "RegionCGDOffice": "สำนักงานคลังเขต 1",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 13",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 1",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 1",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 4 สระบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 4",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 4 สระบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 16 ชัยนาท",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 7",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 13",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 1",
        "Region_CustomHouse": "ด่านศุลกากรสังขละบุรี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 1",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 3 จังหวัดพิจิตร",
        "Region_NESDC_NationalAccounts": "ภาคกลาง",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 12",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาลพบุรี",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 1",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 3",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคกลาง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำชี, ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำป่าสัก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 2 จังหวัดปทุมธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 4 สระบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 4 จังหวัดสระบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 5 (สระบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 10",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 15",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาลพบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 1",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 1 (พระนครศรีอยุธยา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "53",
        "ProvinceMOI_ID": "52",
        "ProvinceNameThai": "จังหวัดลำปาง",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 10",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนบน)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนบน",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "61",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 5",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 5",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 1",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 2",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 1 (ลำปาง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 9",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคเหนือ) จังหวัดเชียงใหม่",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 6",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 35",
        "RegionFineArts": "สำนักศิลปากรที่ 7 เชียงใหม่",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานลำปาง",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 5",
        "RegionAdministrativeCourt": "ศาลปกครองเชียงใหม่",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 5",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 5",
        "RegionRD": "สำนักงานสรรพากรภาค 8",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 1",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 9",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 3",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 15",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 1 เชียงใหม่",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 1",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 1 เชียงใหม่",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 10 ลำปาง",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 9",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 1",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือบน",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 32",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 5",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 5",
        "Region_CustomHouse": "ด่านศุลกากรท่าอากาศยานเชียงใหม่",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 7",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 1",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 15",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 1 จังหวัดเชียงใหม่",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 10",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาลำปาง ลำพูน",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 15",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 6",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 6 - 7 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 15",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 7 เชียงใหม่",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมล้านนา",
        "RiverBasin": "ลุ่มน้ำวัง, ลุ่มน้ำยม",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 15",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 10 จังหวัดลำปาง",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 1 เชียงใหม่",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 1 จังหวัดเชียงใหม่",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 1",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ เชียงใหม่",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 5",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 3 (ลำปาง)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 2",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 1",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 31",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาเชียงใหม่",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 5 (ลำปาง)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 3 เชียงใหม่"
    },
    {
        "ProvinceNo": "54",
        "ProvinceMOI_ID": "51",
        "ProvinceNameThai": "จังหวัดลำพูน",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 10",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนบน)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนบน",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "61",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 5",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 5",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 1",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 1",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 1 (ลำปาง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 9",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคเหนือ) จังหวัดเชียงใหม่",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 6",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 35",
        "RegionFineArts": "สำนักศิลปากรที่ 7 เชียงใหม่",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานลำปาง",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 5",
        "RegionAdministrativeCourt": "ศาลปกครองเชียงใหม่",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 5",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 5",
        "RegionRD": "สำนักงานสรรพากรภาค 8",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 1",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 8",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 3",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 15",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 1 เชียงใหม่",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 1",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 1 เชียงใหม่",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 10 ลำปาง",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 9",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 1",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือบน",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 33",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 5",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 5",
        "Region_CustomHouse": "ด่านศุลกากรท่าอากาศยานเชียงใหม่",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 7",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 1",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 15",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 1 จังหวัดเชียงใหม่",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 10",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาลำปาง ลำพูน",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 15",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 7",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 6 - 7 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 15",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 7 เชียงใหม่",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมล้านนา",
        "RiverBasin": "ลุ่มน้ำปิง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 15",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 9 จังหวัดเชียงใหม่",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 1 เชียงใหม่",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 1 จังหวัดเชียงใหม่",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 1",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ เชียงใหม่",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 5",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 1 (เชียงใหม่)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 1",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 1",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 32",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาเชียงใหม่",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 5 (ลำปาง)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 3 เชียงใหม่"
    },
    {
        "ProvinceNo": "55",
        "ProvinceMOI_ID": "42",
        "ProvinceNameThai": "จังหวัดเลย",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 6",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "51",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 8",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 9",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 4 (ขอนแก่น)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 7",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุดรธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 8",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 19",
        "RegionFineArts": "สำนักศิลปากรที่ 8 ขอนแก่น",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานเลย",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองอุดรธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 6",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 6",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 10",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 8 อุดรธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 8",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 8 อุดรธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 14 อุดรธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 5",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 3",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 28",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรเชียงคาน, ด่านศุลกากรท่าลี่",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 5",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 10",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 4 จังหวัดอุดรธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 7",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาเลย หนองบัวลำภู",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 10",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 8",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 10 ขอนแก่น",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำโขง",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี, ลุ่มน้ำน่าน, ลุ่มน้ำป่าสัก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 7 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 8 อุดรธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 8 จังหวัดอุดรธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 6 (อุดรธานี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 5",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 3",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 24",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาหนองคาย",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "56",
        "ProvinceMOI_ID": "33",
        "ProvinceNameThai": "จังหวัดศรีสะเกษ",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 5",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "55",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 3",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 3",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 10",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 12",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 11 (อุบลราชธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 8",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุบลราชธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 4",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 28",
        "RegionFineArts": "สำนักศิลปากรที่ 10 นครราชสีมา",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานอุบลราชธานี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 3",
        "RegionAdministrativeCourt": "ศาลปกครองอุบลราชธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 3",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 3",
        "RegionRD": "สำนักงานสรรพากรภาค 9",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 8",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 5",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 14",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 10 อุบลราชธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 10",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 10 อุบลราชธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 13 อุบลราชธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 4",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 11",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 25",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 3",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 3",
        "Region_CustomHouse": "ด่านศุลกากรช่องสะงำ",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 4",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 14",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 7 จังหวัดอุบลราชธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 2",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาศรีสะเกษ ยโสธร",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 14",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 10",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 14",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 12 อุบลราชธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมอีสานใต้",
        "RiverBasin": "ลุ่มน้ำชี, ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 14",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 5 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 10 อุบลราชธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 10 จังหวัดอุบลราชธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 2",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 7",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 สาขาอุบลราชธานี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 8",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 5",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 22",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาอุบลราชธานี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 10",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 3 (นครราชสีมา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "57",
        "ProvinceMOI_ID": "47",
        "ProvinceNameThai": "จังหวัดสกลนคร",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 6",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "52",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 8",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 9",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 10 (อุดรธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 7",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุดรธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 5",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 23",
        "RegionFineArts": "สำนักศิลปากรที่ 8 ขอนแก่น",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครพนม",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองอุดรธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 6",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 6",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 11",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 8 อุดรธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 8",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 8 อุดรธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 7 สกลนคร",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 6",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 3",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 29",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรนครพนม",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 5",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 11",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 5 จังหวัดขอนแก่น",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 15",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสกลนคร",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 11",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 8",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 11",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 9 อุดรธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 11",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 8 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 8 อุดรธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 8 จังหวัดอุดรธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 6 สาขานครพนม",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 5",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 3",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 25",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครพนม",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 10",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "58",
        "ProvinceMOI_ID": "90",
        "ProvinceNameThai": "จังหวัดสงขลา",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 12",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนล่าง",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "21",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอ่าวไทย",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 9",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 9",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 12",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 16",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 12 (สงขลา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 5",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคใต้) จังหวัดยะลา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 12",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 16",
        "RegionFineArts": "สำนักศิลปากรที่ 11 สงขลา",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานหาดใหญ่",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 9",
        "RegionAdministrativeCourt": "ศาลปกครองสงขลา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 9",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 9",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 9",
        "RegionCGDOffice": "สำนักงานคลังเขต 9",
        "RegionRD": "สำนักงานสรรพากรภาค 12",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 10",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 15",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 6",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 5",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 12 ยะลา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 12",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 12 สงขลา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 12 สงขลา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 11",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 9",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 42",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 9",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 9",
        "Region_CustomHouse": "ด่านศุลกากรท่าอากาศยานหาดใหญ่, ด่านศุลกากรบ้านประกอบ, ด่านศุลกากรปาดังเบซาร์, ด่านศุลกากรสงขลา, ด่านศุลกากรสะเดา",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 9",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 8",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 5",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 11 จังหวัดสงชลา",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 4",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสงขลา สตูล",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 5",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 18",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 15 สงขลา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มน้ำทะเลสาบสงขลา, เขตพัฒนาการท่องเที่ยวพหุวัฒนธรรมชายแดนภาคใต้",
        "RiverBasin": "ลุ่มน้ำทะเลสาบสงขลา, ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนล่าง, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 17 จังหวัดสงขลา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 12 สงขลา",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 12 จังหวัดสงขลา",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 5",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ สงขลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 5 (ศป.ข.ภาค 5)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 4",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 13 (สงขลา)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 16",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 8",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 5",
        "DistrictOffice_NBTC": "N/A",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสงขลา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 4",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 9",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 9 (สงขลา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 1 สงขลา"
    },
    {
        "ProvinceNo": "59",
        "ProvinceMOI_ID": "91",
        "ProvinceNameThai": "จังหวัดสตูล",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 12",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนล่าง",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "22",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอันดามัน",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันตก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 9",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 9",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 12",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 16",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 12 (สงขลา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 5",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคใต้) จังหวัดยะลา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 12",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 16",
        "RegionFineArts": "สำนักศิลปากรที่ 11 สงขลา",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสตูล",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 9",
        "RegionAdministrativeCourt": "ศาลปกครองสงขลา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 9",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 9",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 9",
        "RegionCGDOffice": "สำนักงานคลังเขต 9",
        "RegionRD": "สำนักงานสรรพากรภาค 12",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 10",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 15",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 6",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 6",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 12 ยะลา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 12",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 12 สงขลา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 12 สงขลา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 11",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 9",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 42",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 9",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 9",
        "Region_CustomHouse": "ด่านศุลกากรสตูล, ด่านศูลกากรวังประจัน",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 4",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 9",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 8",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 6",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 11 จังหวัดสงชลา",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 5",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสงขลา สตูล",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 6",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 18",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 17 - 18 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 15 สงขลา",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอันดามัน",
        "RiverBasin": "ลุ่มน้ำทะเลสาบสงขลา, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 6",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 17 จังหวัดสงขลา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 12/1 ตรัง",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 12 จังหวัดสงขลา",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 5",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ สงขลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 5 (ศป.ข.ภาค 5)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 4",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 13 (สงขลา)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 16",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 8",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "N/A",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสตูล",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 5",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 9",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 9 (สงขลา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 1 สงขลา"
    },
    {
        "ProvinceNo": "60",
        "ProvinceMOI_ID": "11",
        "ProvinceNameThai": "จังหวัดสมุทรปราการ",
        "Region_VaccineRollout_MOPH": "กรุงเทพมหานครและปริมณฑล",
        "Region_RDPB": "ปริมณฑล",//"ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 1",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตนครหลวง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "12",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางปริมณฑล",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 6",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 13",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 8 (ราชบุรี)",
        "WaterAuthorities_ServiceArea": "การประปานครหลวง",
        "RegionWaterAuthorities": "N/A",
        "RegionElectricityAuthorities": "การไฟฟ้านครหลวง",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 6",
        "RegionFineArts": "สำนักศิลปากรที่ 1 ราชบุรี",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานฉะเชิงเทรา",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 3",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 2",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 6 ชลบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 6",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 6 ระยอง",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 1 ปทุมธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 1",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 11",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "N/A",
        "Region_CustomsBureau": "สำนักงานศุลกากรกรุงเทพ, สำนักงานศุลกากรตรวจของผู้โดยสารท่าอากาศยานสุวรรณภูมิ, สำนักงานศุลกากรตรวจสินค้าท่าอากาศยานสุวรรณภูมิ",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 2",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "กรุงเทพมหานครและปริมณฑล",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 16",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสมุทรปราการ",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 2",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 1",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 2",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 1 นนทบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตชายฝั่งอ่าวไทย",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำบางปะกง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 2",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 1 จังหวัดปทุมธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 6 ชลบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 6 จังหวัดชลบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "N/A",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 (ราชบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 11",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 2",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 11",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสมุทรปราการ",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์นครหลวง 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 10 (สมุทรปราการ)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "61",
        "ProvinceMOI_ID": "75",
        "ProvinceNameThai": "จังหวัดสมุทรสงคราม",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 4",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันตก",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "14",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 7",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 7",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 5",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 8",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 8 (ราชบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 3",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคใต้) จังหวัดเพชรบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 10",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 10",
        "RegionFineArts": "สำนักศิลปากรที่ 1 ราชบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสมุทรสงคราม",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 7",
        "RegionAdministrativeCourt": "ศาลปกครองเพชรบุรี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 7",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 7",
        "RegionCGDOffice": "สำนักงานคลังเขต 7",
        "RegionRD": "สำนักงานสรรพากรภาค 6",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 12",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 12",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 4",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 5 ราชบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 5",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 5 ราชบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 4 ประจวบคีรีขันธ์",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 3",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 10",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 16",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 7",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 7",
        "Region_CustomHouse": "ด่านศุลกากรแม่กลอง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 10",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 4",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันตก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 14",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสมุทรสาคร สมุทรสงคราม",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 4",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 2 จังหวัดราชบุรี",
        "Region_MonkMahaNikai": "ภาค 15",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 4",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันตก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 3 เพชรบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตชายฝั่งอ่าวไทย",
        "RiverBasin": "ลุ่มน้ำท่าจีน, ลุ่มน้ำแม่กลอง, ลุ่มน้ำเพชรบุรี - ประจวบคีรีขันธ์",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 4",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 16 จังหวัดเพชรบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 5 สมุทรสงคราม",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 5 จังหวัดราชบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "N/A",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 สาขาเพชรบุรี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 13",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันตก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 7",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 8",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 16",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสมุทรสงคราม",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 3",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 7",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 7 (ราชบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "62",
        "ProvinceMOI_ID": "74",
        "ProvinceNameThai": "จังหวัดสมุทรสาคร",
        "Region_VaccineRollout_MOPH": "กรุงเทพมหานครและปริมณฑล",
        "Region_RDPB": "ปริมณฑล",//"ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 4",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตนครหลวง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "14",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 7",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 7",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 5",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 5",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 8 (ราชบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 3",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคกลาง) จังหวัดนครปฐม",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 10",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 10",
        "RegionFineArts": "สำนักศิลปากรที่ 1 ราชบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสมุทรสงคราม",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 7",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 7",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 7",
        "RegionCGDOffice": "สำนักงานคลังเขต 7",
        "RegionRD": "สำนักงานสรรพากรภาค 6",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 12",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 3",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 4",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 5 ราชบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 5",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 5 ราชบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 1 ปทุมธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 3",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 10",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 16",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 7",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 7",
        "Region_CustomHouse": "ด่านศุลกากรแม่กลอง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 10",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 4",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "กรุงเทพมหานครและปริมณฑล",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 14",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสมุทรสาคร สมุทรสงคราม",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 4",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 2 จังหวัดราชบุรี",
        "Region_MonkMahaNikai": "ภาค 14",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 4",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันตก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 1 นนทบุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตชายฝั่งอ่าวไทย",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำท่าจีน, ลุ่มน้ำแม่กลอง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 4",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 16 จังหวัดเพชรบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 5 สมุทรสงคราม",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 5 จังหวัดราชบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "N/A",
        "Region_Archives": "สำนักหอจดหมายเหตุแห่งชาติ",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 สาขาเพชรบุรี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 11, สำนักงานชลประทานที่ 13",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันตก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 7",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 8",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 16",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสมุทรสาคร",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 3",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 7",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 7 (ราชบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "63",
        "ProvinceMOI_ID": "27",
        "ProvinceNameThai": "จังหวัดสระแก้ว",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออก",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 3",
        "Region_SenatorFieldWork": "ภาคตะวันออก",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออก",
        "RegionID": "4",
        "RegionName": "ภาคตะวันออก",
        "ProvincialClusterID": "42",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออก 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออก",
        "RegionTMD": "ภาคตะวันออก",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคตะวันออก",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 2",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 2",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 6",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 7",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออก",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 9 (ระยอง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 1",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคกลาง) จังหวัดพระนครศรีอยุธยา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 2",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 7",
        "RegionFineArts": "สำนักศิลปากรที่ 5 ปราจีนบุรี",
        "RegionTAT": "ภาคตะวันออก",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานนครนายก",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 2",
        "RegionAdministrativeCourt": "ศาลปกครองระยอง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 2",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 2",
        "RegionCGDOffice": "สำนักงานคลังเขต 2",
        "RegionRD": "สำนักงานสรรพากรภาค 5",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 11",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 2",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 7",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 2",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 9",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 6 ชลบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 6",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 6 ระยอง",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 3 ปราจีนบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 2",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 6",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 19",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 2",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 2",
        "Region_CustomHouse": "ด่านศุลกากรอรัญประเทศ",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 2",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 6",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 9",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 9 จังหวัดชลบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 3",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสระแก้ว",
        "Region_SSOProvincialOffice": "ภาคตะวันออก",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 9",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 3 จังหวัดระยอง",
        "Region_MonkMahaNikai": "ภาค 12",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "ภาค 12 - 13 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 1",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 4 ฉะเชิงเทรา",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวผืนป่ามรดกโลกดงพญาเย็น - เขาใหญ่",
        "RiverBasin": "ลุ่มน้ำมูล, ลุ่มน้ำบางปะกง, ลุ่มน้ำโตนเลสาบ",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 9",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 4 จังหวัดนครนายก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 6 ชลบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 6 จังหวัดชลบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออก",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 4",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 3",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดจันทบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคตะวันออก",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 9 สาขาปราจีนบุรี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 9",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 6",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 14",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกรุงเทพฯ ปริมณฑลและตะวันออก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาจันทบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 6",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 2",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 2 (ชลบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "64",
        "ProvinceMOI_ID": "19",
        "ProvinceNameThai": "จังหวัดสระบุรี",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 2",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคกลาง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "11",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนบน",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 4",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 7",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 3 (สระบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 2",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคกลาง) จังหวัดพระนครศรีอยุธยา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 4",
        "RegionFineArts": "สำนักศิลปากรที่ 3 พระนครศรีอยุธยา",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานพระนครศรีอยุธยา",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 1",
        "RegionCGDOffice": "สำนักงานคลังเขต 1",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 13",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 1",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 1",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 4 สระบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 4",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 4 สระบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 3 ปราจีนบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 1",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 18",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 1",
        "Region_CustomHouse": "ด่านศุลกากรอรัญประเทศ",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 1",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "ภาคกลาง",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 12",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสระบุรี",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 1",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 2",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคกลาง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวผืนป่ามรดกโลกดงพญาเย็น - เขาใหญ่",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำป่าสัก, ลุ่มน้ำบางปะกง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 2 จังหวัดปทุมธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 4 สระบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 4 จังหวัดสระบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 5 (สระบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 10",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 15",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาลพบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 1",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 1 (พระนครศรีอยุธยา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 6 นครราชสีมา"
    },
    {
        "ProvinceNo": "65",
        "ProvinceMOI_ID": "17",
        "ProvinceNameThai": "จังหวัดสิงห์บุรี",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 2",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคกลาง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "11",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนบน",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 4",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 6",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 2",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคเหนือ) จังหวัดลพบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 5",
        "RegionFineArts": "สำนักศิลปากรที่ 3 พระนครศรีอยุธยา",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานลพบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 1",
        "RegionCGDOffice": "สำนักงานคลังเขต 1",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 13",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 11",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 1",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 4 สระบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 4",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 4 สระบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 16 ชัยนาท",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 7",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 13",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 1",
        "Region_CustomHouse": "ด่านศุลกากรสังขละบุรี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 1",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 3 จังหวัดพิจิตร",
        "Region_NESDC_NationalAccounts": "ภาคกลาง",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 12",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสิงห์บุรี อ่างทอง",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 1",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 3",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคกลาง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำเจ้าพระยาตอนกลาง",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำท่าจีน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 13 จังหวัดชัยนาท",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 4 สระบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 4 จังหวัดสระบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 5 (สระบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 10, สำนักงานชลประทานที่ 12",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 13",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาอยุธยา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 1",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 1 (พระนครศรีอยุธยา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "66",
        "ProvinceMOI_ID": "64",
        "ProvinceNameThai": "จังหวัดสุโขทัย",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 8",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "63",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 2",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 3",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 7 (กำแพงเพชร)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคเหนือ) จังหวัดพิษณุโลก",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 9",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 38",
        "RegionFineArts": "สำนักศิลปากรที่ 6 สุโขทัย",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสุโขทัย",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองพิษณุโลก",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 6",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 7",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 2",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 10",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 17",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 2 พิษณุโลก",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 2",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 2 พิษณุโลก",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 9 พิษณุโลก",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 8",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 2",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 39",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรแม่สอด",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 6",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 2",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 17",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 2 จังหวัดพิษณุโลก",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 11",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสุโขทัย",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 17",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 5",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 4 - 5 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 6 พิษณุโลก",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวมรดกโลกด้านวัฒนธรรม",
        "RiverBasin": "ลุ่มน้ำยม, ลุ่มน้ำน่าน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 11 จังหวัดพิษณุโลก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 2 พิษณุโลก",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 2 จังหวัดพิษณุโลก",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 4 (ตาก)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 4",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 9",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 33",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาพิษณุโลก",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 6",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "67",
        "ProvinceMOI_ID": "72",
        "ProvinceNameThai": "จังหวัดสุพรรณบุรี",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 2",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคกลาง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "13",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 7",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 7",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 5",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 5",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 3",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคกลาง) จังหวัดนครปฐม",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 9",
        "RegionFineArts": "สำนักศิลปากรที่ 2 สุพรรณบุรี",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสุพรรณบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 7",
        "RegionAdministrativeCourt": "ศาลปกครองสุพรรณบุรี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 7",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 7",
        "RegionCGDOffice": "สำนักงานคลังเขต 7",
        "RegionRD": "สำนักงานสรรพากรภาค 6",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 12",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 3",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 3",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 5 ราชบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 5",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 5 ราชบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 2 สุพรรณบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 3",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 17",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 7",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 7",
        "Region_CustomHouse": "ด่านศุลกากรสังขละบุรี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 10",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 3",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 8 จังหวัดสุพรรณบุรี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันตก",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 13",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสุพรรณบุรี",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 3",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 2 จังหวัดราชบุรี",
        "Region_MonkMahaNikai": "ภาค 14",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 3",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันตก",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำท่าจีน, ลุ่มน้ำแม่กลอง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 3",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 15 จังหวัดเพชรบุรี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 5 สมุทรสงคราม",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 5 จังหวัดราชบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 1",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 10 (ราชบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 11, สำนักงานชลประทานที่ 12, สำนักงานชลประทานที่ 13",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันตก",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 7",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 13",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสุพรรณบุรี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 7",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 7 (ราชบุรี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 7 ราชบุรี"
    },
    {
        "ProvinceNo": "68",
        "ProvinceMOI_ID": "84",
        "ProvinceNameThai": "จังหวัดสุราษฎร์ธานี",
        "Region_VaccineRollout_MOPH": "ภาคใต้",
        "Region_RDPB": "ภาคใต้",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 11",
        "Region_SenatorFieldWork": "ภาคใต้",
        "Region_JFO": "ภาคใต้",
        "Region_TCGOffice": "สำนักงานเขตภาคใต้ตอนบน",
        "RegionID": "2",
        "RegionName": "ภาคใต้",
        "ProvincialClusterID": "21",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคใต้ฝั่งอ่าวไทย",
        "RegionCGDWelfareIntegrationSystem": "ภาคใต้",
        "RegionTMD": "ภาคใต้ฝั่งตะวันออก",
        "RegionECT": "ภาคใต้",
        "RegionNSO": "ภาคใต้",
        "RegionOPSIndustry": "ภาคใต้",
        "RegionArmy": "กองทัพภาคที่ 4",
        "RegionPolice": "ตำรวจภูธรภาค 8",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 8",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 11",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 14",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคใต้",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 6 (ตรัง)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 4",
        "RegionWaterAuthorities": "ภาค 5",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคใต้) จังหวัดนครศรีธรรมราช",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 11",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 11",
        "RegionFineArts": "สำนักศิลปากรที่ 12 นครศรีธรรมราช",
        "RegionTAT": "ภาคใต้",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสุราษฎร์ธานี, การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานเกาะสมุย",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 8",
        "RegionAdministrativeCourt": "ศาลปกครองนครศรีธรรมราช",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 8",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 8",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 8",
        "RegionCGDOffice": "สำนักงานคลังเขต 8",
        "RegionRD": "สำนักงานสรรพากรภาค 11",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 9",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 13",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 5",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 5",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 5",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 11 นครศรีธรรมราช",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 11",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 11 สุราษฎร์ธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 11 สุราษฎร์ธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 10",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 8",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคใต้",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 45",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 8",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 8",
        "Region_CustomHouse": "ด่านศุลกากรเกาะสมุย, ด่านศุลกากรบ้านดอน",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 8",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 7",
        "Region_MOI": "ภาคใต้",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 5",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 4",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 10 จังหวัดสุราษฎร์ธานี",
        "Region_NESDC_NationalAccounts": "ภาคใต้",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคใต้",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 4",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสุราษฎร์ธานี ชุมพร",
        "Region_SSOProvincialOffice": "ภาคใต้",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 5",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 5 จังหวัดสงขลา",
        "Region_MonkMahaNikai": "ภาค 16",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนใต้",
        "Region_MonkDhammyuttika": "ภาค 16 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคใต้ตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 4",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 13 สุราษฎร์ธานี",
        "Region_OPSTourismandSports": "ภาคใต้",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวหมู่เกาะทะเลใต้",
        "RiverBasin": "ลุ่มน้ำภาคใต้ฝั่งตะวันออกตอนบน, ลุ่มน้ำภาคใต้ฝั่งตะวันตก",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 5",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 19 จังหวัดสุราษฎร์ธานี",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 11 สุราษฎร์ธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 11 จังหวัดนครศรีธรรมราช",
        "Region_ThailandTrustMark_DITP": "ภาคใต้",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 6",
        "Region_OCSB": "N/A",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ สงขลา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 4 (ศป.ข.ภาค 4)",
        "Region_StateAuditOffice": "ภาคใต้",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 3",
        "RegionalHoliday": "ภาคใต้",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 11 (สุราษฎร์ธานี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 15",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคใต้",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 10",
        "Region_DMCR": "สำนักงานทรัพยากรทางทะเลและชายฝั่งที่ 4 ",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 44",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 4",
        "Region_CODIOffice": "สำนักงานภาคใต้",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาสุราษฎร์ธานี, สำนักงานเจ้าท่าภูมิภาคสาขาเกาะพะงัน, สำนักงานเจ้าท่าภูมิภาคสาขาเกาะสมุย",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 4",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 8",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 8 (สุราษฎร์ธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 4 ภูเก็ต"
    },
    {
        "ProvinceNo": "69",
        "ProvinceMOI_ID": "32",
        "ProvinceNameThai": "จังหวัดสุรินทร์",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 5",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "54",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 3",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 3",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 9",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 11",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 5 (นครราชสีมา)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 8",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคตะวันออกเฉียงเหนือ) จังหวัดนครราชสีมา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 3",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 33",
        "RegionFineArts": "สำนักศิลปากรที่ 10 นครราชสีมา",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสุรินทร์",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 3",
        "RegionAdministrativeCourt": "ศาลปกครองนครราชสีมา",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 3",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 3",
        "RegionRD": "สำนักงานสรรพากรภาค 9",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 7",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 4",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 13",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 9 นครราชสีมา",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 9",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 9 นครราชสีมา",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 5 นครราชสีมา",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 4",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 5",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 25",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 3",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 3",
        "Region_CustomHouse": "ด่านศุลกากรช่องจอม",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 3",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 13",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 6 จังหวัดนครราชสีมา",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 9",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสุรินทร์",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 13",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 11",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 13",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 11 นครราชสีมา",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมอีสานใต้",
        "RiverBasin": "ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 13",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 5 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 9 นครราชสีมา",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 9 จังหวัดนครราชสีมา",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 2",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 7",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 8 (นครราชสีมา)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 8",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 5",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 22",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครราชสีมา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 3",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 3 (นครราชสีมา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "70",
        "ProvinceMOI_ID": "43",
        "ProvinceNameThai": "จังหวัดหนองคาย",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 6",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "51",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 8",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 9",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 10 (อุดรธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 7",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุดรธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 5",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 21",
        "RegionFineArts": "สำนักศิลปากรที่ 8 ขอนแก่น",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานอุดรธานี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองอุดรธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 6",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 6",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 10",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 8 อุดรธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 8",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 8 อุดรธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 14 อุดรธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 5",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 3",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 24",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรหนองคาย",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 5",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 10",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 4 จังหวัดอุดรธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 7",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาหนองคาย",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 10",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 8",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 9 อุดรธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำโขง",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 7 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 8 อุดรธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 8 จังหวัดอุดรธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 6 (อุดรธานี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 5",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 3",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 24",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาหนองคาย",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "71",
        "ProvinceMOI_ID": "39",
        "ProvinceNameThai": "จังหวัดหนองบัวลำภู",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 6",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "51",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 8",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 10",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 4 (ขอนแก่น)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 7",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุดรธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 5",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 19",
        "RegionFineArts": "สำนักศิลปากรที่ 8 ขอนแก่น",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานเลย",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองอุดรธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 6",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 6",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 10",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 8 อุดรธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 8",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 8 อุดรธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 14 อุดรธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 5",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 3",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 28",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรเชียงคาน",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 5",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 10",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 4 จังหวัดอุดรธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 7",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาเลย หนองบัวลำภู",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 10",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 8",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 9 อุดรธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวธรณีวิทยาถิ่นอีสาน",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 7 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 8 อุดรธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 8 จังหวัดอุดรธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 6 (อุดรธานี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 5",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 3",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 24",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาหนองคาย",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "72",
        "ProvinceMOI_ID": "15",
        "ProvinceNameThai": "จังหวัดอ่างทอง",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคกลาง",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 1",
        "Region_SenatorFieldWork": "ภาคกลาง",
        "Region_JFO": "ภาคกลาง",
        "Region_TCGOffice": "สำนักงานเขตภาคกลาง",
        "RegionID": "1",
        "RegionName": "ภาคกลาง",
        "ProvincialClusterID": "11",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคกลางตอนบน",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคกลาง",
        "RegionOPSIndustry": "ภาคกลาง",
        "RegionArmy": "กองทัพภาคที่ 1",
        "RegionPolice": "ตำรวจภูธรภาค 1",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 1",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 4",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 6",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 2",
        "RegionWaterAuthorities": "ภาค 4",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคกลาง) จังหวัดพระนครศรีอยุธยา",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 1",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 5",
        "RegionFineArts": "สำนักศิลปากรที่ 3 พระนครศรีอยุธยา",
        "RegionTAT": "ภาคกลาง",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานสุพรรณบุรี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 1",
        "RegionAdministrativeCourt": "ศาลปกครองกลาง",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 1",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 1",
        "RegionCGDOffice": "สำนักงานคลังเขต 1",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 13",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 1",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 8",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 1",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 1",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 4 สระบุรี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 4",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 4 สระบุรี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 2 สุพรรณบุรี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 1",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 7",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคกลาง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 13",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 1",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 1",
        "Region_CustomHouse": "ด่านศุลกากรสังขละบุรี",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 1",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคกลาง",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 1",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 3",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 3 จังหวัดพิจิตร",
        "Region_NESDC_NationalAccounts": "ภาคกลาง",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคกลาง",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 12",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาสิงห์บุรี อ่างทอง",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 1",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 1 จังหวัดชัยนาท",
        "Region_MonkMahaNikai": "ภาค 2",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคกลาง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคกลาง",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยววิถีชีวิตลุ่มแม่น้ำเจ้าพระยาตอนกลาง",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำท่าจีน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 1",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 13 จังหวัดชัยนาท",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 4 สระบุรี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 4 จังหวัดสระบุรี",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "N/A",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 1 (ศป.ข.ภาค 1)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 2",
        "RegionalHoliday": "ภาคกลาง",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 5 (สระบุรี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 10, สำนักงานชลประทาน 12",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 15",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 1",
        "Region_CODIOffice": "สำนักงานภาคกลางและภาคตะวันตก",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาอยุธยา",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 2",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 1",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 1 (พระนครศรีอยุธยา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "73",
        "ProvinceMOI_ID": "37",
        "ProvinceNameThai": "จังหวัดอำนาจเจริญ",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 7",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "55",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 3",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 3",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 10",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 12",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 11 (อุบลราชธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 8",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุบลราชธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 4",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 29",
        "RegionFineArts": "สำนักศิลปากรที่ 9 อุบลราชธานี",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานอุบลราชธานี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 3",
        "RegionAdministrativeCourt": "ศาลปกครองอุบลราชธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 3",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 3",
        "RegionRD": "สำนักงานสรรพากรภาค 9",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 8",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 5",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 14",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 10 อุบลราชธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 10",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 10 อุบลราชธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 13 อุบลราชธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 6",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 11",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 22",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 3",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 3",
        "Region_CustomHouse": "ด่านศุลกากรเขมราฐ",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 4",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 14",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 7 จังหวัดอุบลราชธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 2",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาอุบลราชธานี อำนาจเจริญ",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 14",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 10",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 14",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 12 อุบลราชธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 14",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 6 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 10 อุบลราชธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 10 จังหวัดอุบลราชธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 2",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 7",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 สาขาอุบลราชธานี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 7",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 11",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 22",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาอุบลราชธานี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 10",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 3 (นครราชสีมา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "74",
        "ProvinceMOI_ID": "41",
        "ProvinceNameThai": "จังหวัดอุดรธานี",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 6",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนบน)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "51",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนบน 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 4",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 4",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 8",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 9",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนบน",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 10 (อุดรธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 7",
        "RegionWaterAuthorities": "ภาค 2",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 1 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุดรธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 5",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 20",
        "RegionFineArts": "สำนักศิลปากรที่ 8 ขอนแก่น",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานอุดรธานี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 4",
        "RegionAdministrativeCourt": "ศาลปกครองอุดรธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 4",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 4",
        "RegionCGDOffice": "สำนักงานคลังเขต 4",
        "RegionRD": "สำนักงานสรรพากรภาค 10",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 6",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 6",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 1",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 10",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 8 อุดรธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 8",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 8 อุดรธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 14 อุดรธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 5",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 3",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 24",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 4",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 4",
        "Region_CustomHouse": "ด่านศุลกากรหนองคาย",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 5",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 3",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 10",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 4 จังหวัดอุดรธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 7",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาอุดรธานี",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 10",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 8",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 9 อุดรธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวธรณีวิทยาถิ่นอีสาน",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 10",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 7 จังหวัดขอนแก่น",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 8 อุดรธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 8 จังหวัดอุดรธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 3",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 8",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 6 (อุดรธานี)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 5",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนบน",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 3",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 24",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาหนองคาย",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 4",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 4 (อุดรธานี)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    },
    {
        "ProvinceNo": "75",
        "ProvinceMOI_ID": "53",
        "ProvinceNameThai": "จังหวัดอุตรดิตถ์",
        "Region_VaccineRollout_MOPH": "ภาคเหนือ",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 9",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "63",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 1",
        "RegionCGDWelfareIntegrationSystem": "ภาคเหนือ",
        "RegionTMD": "ภาคเหนือ",
        "RegionECT": "ภาคเหนือ",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 2",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 3",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 7 (กำแพงเพชร)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคเหนือ) จังหวัดพิษณุโลก",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 8",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 39",
        "RegionFineArts": "สำนักศิลปากรที่ 6 สุโขทัย",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานแพร่",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองพิษณุโลก",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 5",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 7",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 2",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 9",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 17",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 2 พิษณุโลก",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 2",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 2 พิษณุโลก",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 9 พิษณุโลก",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 8",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 2",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 35",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรทุ่งช้าง",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 6",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 2",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 17",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 2 จังหวัดพิษณุโลก",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 11",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาพิษณุโลก อุตรดิตถ์",
        "Region_SSOProvincialOffice": "ภาคเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 17",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 5",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนเหนือ",
        "Region_MonkDhammyuttika": "ภาค 4 - 5 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 5",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 6 พิษณุโลก",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวเมืองเก่ามีชีวิต",
        "RiverBasin": "ลุ่มน้ำยม, ลุ่มน้ำน่าน",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 17",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 12 จังหวัดพิษณุโลก",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 2 พิษณุโลก",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 2 จังหวัดพิษณุโลก",
        "Region_ThailandTrustMark_DITP": "ภาคเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 2",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร พะเยา",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 3 (ลำปาง)",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 3",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 9",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 33",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาแพร่",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 5",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "76",
        "ProvinceMOI_ID": "61",
        "ProvinceNameThai": "จังหวัดอุทัยธานี",
        "Region_VaccineRollout_MOPH": "ภาคกลาง",
        "Region_RDPB": "ภาคเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 8",
        "Region_SenatorFieldWork": "ภาคเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคเหนือตอนล่าง",
        "RegionID": "6",
        "RegionName": "ภาคเหนือ",
        "ProvincialClusterID": "64",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคเหนือตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคกลาง",
        "RegionTMD": "ภาคกลาง",
        "RegionECT": "ภาคกลาง",
        "RegionNSO": "ภาคเหนือ",
        "RegionOPSIndustry": "ภาคเหนือ",
        "RegionArmy": "กองทัพภาคที่ 3",
        "RegionPolice": "ตำรวจภูธรภาค 6",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 6",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 3",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 4",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคกลาง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 2 (สุพรรณบุรี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 10",
        "RegionWaterAuthorities": "ภาค 1",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 3 (ภาคเหนือ) จังหวัดลพบุรี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 9",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 42",
        "RegionFineArts": "สำนักศิลปากรที่ 4 ลพบุรี",
        "RegionTAT": "ภาคเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานอุทัยธานี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 6",
        "RegionAdministrativeCourt": "ศาลปกครองนครสวรรค์",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 6",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 6",
        "RegionCGDOffice": "สำนักงานคลังเขต 6",
        "RegionRD": "สำนักงานสรรพากรภาค 4",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 3",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 11",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 4",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 3",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 18",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 3 นครสวรรค์",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 3",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 3 นครสวรรค์",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 16 ชัยนาท",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 7",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 12",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคเหนือล่าง",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 31",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 6",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 6",
        "Region_CustomHouse": "ด่านศุลกากรแม่สอด",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 3",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 1",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 5",
        "Region_MOI": "ภาคเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 18",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 1",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 3 จังหวัดพิจิตร",
        "Region_NESDC_NationalAccounts": "ภาคเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 18",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาอุทัยธานี ชัยนาท",
        "Region_SSOProvincialOffice": "ภาคกลาง",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 18",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 6 จังหวัดเชียงใหม่",
        "Region_MonkMahaNikai": "ภาค 3",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนกลาง",
        "Region_MonkDhammyuttika": "ภาค 1 - 2 - 3 (ธรรมยุต)",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 18",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 2",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 2 สิงห์บุรี",
        "Region_OPSTourismandSports": "ภาคเหนือ",
        "Region_TourismDevelopmentArea": "N/A",
        "RiverBasin": "ลุ่มน้ำเจ้าพระยา, ลุ่มน้ำสะแกกรัง, ลุ่มน้ำท่าจีน, ลุ่มน้ำแม่กลอง",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 18",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 13 จังหวัดชัยนาท",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 3 นครสวรรค์",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 3 จังหวัดนครสวรรค์",
        "Region_ThailandTrustMark_DITP": "ภาคกลาง",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 7",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 1",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติ จังหวัดสุพรรณบุรี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 2 (ศป.ข.ภาค 2)",
        "Region_StateAuditOffice": "ภาคกลาง",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 6",
        "RegionalHoliday": "ภาคเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 4 สาขานครสวรรค์",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 12",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคกลาง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 2",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 35",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 3",
        "Region_CODIOffice": "สำนักงานภาคเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขานครสวรรค์",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 1",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 6",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 6 (นครสวรรค์)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 5 พิษณุโลก"
    },
    {
        "ProvinceNo": "77",
        "ProvinceMOI_ID": "34",
        "ProvinceNameThai": "จังหวัดอุบลราชธานี",
        "Region_VaccineRollout_MOPH": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RDPB": "ภาคตะวันออกเฉียงเหนือ",
        "Region_RedCrossChapter": "เหล่ากาชาดจังหวัดภาค 7",
        "Region_SenatorFieldWork": "ภาคตะวันออกเฉียงเหนือ (ตอนล่าง)",
        "Region_JFO": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TCGOffice": "สำนักงานเขตภาคตะวันออกเฉียงเหนือตอนล่าง 1",
        "RegionID": "5",
        "RegionName": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialClusterID": "55",
        "ProvincialClusterName": "กลุ่มจังหวัดภาคตะวันออกเฉียงเหนือตอนล่าง 2",
        "RegionCGDWelfareIntegrationSystem": "ภาคตะวันออกเฉียงเหนือ",
        "RegionTMD": "ภาคตะวันออกเฉียงเหนือ",
        "RegionECT": "ภาคตะวันออกเฉียงเหนือ",
        "RegionNSO": "ภาคตะวันออกเฉียงเหนือ",
        "RegionOPSIndustry": "ภาคตะวันออกเฉียงเหนือ",
        "RegionArmy": "กองทัพภาคที่ 2",
        "RegionPolice": "ตำรวจภูธรภาค 3",
        "RegionONCB": "สำนักงานป้องกันและปราบปรามยาเสพติดภาค 3",
        "RegionalHealth": "เขตสุขภาพเพื่อประชาชน เขตพื้นที่ 10",
        "RegionEnvironment": "สำนักงานสิ่งแวดล้อมภาคที่ 12",
        "RegionRoyalRain": "ศูนย์ปฏิบัติการฝนหลวงภาคตะวันออกเฉียงเหนือตอนล่าง",
        "RegionDGR": "สำนักทรัพยากรน้ำบาดาล เขต 11 (อุบลราชธานี)",
        "WaterAuthorities_ServiceArea": "การประปาส่วนภูมิภาคเขต 8",
        "RegionWaterAuthorities": "ภาค 3",
        "RegionElectricityAuthorities": "การไฟฟ้าส่วนภูมิภาค เขต 2 (ภาคตะวันออกเฉียงเหนือ) จังหวัดอุบลราชธานี",
        "RegionLDD": "สำนักงานพัฒนาที่ดินเขต 4",
        "RegionSecondaryEducationalServiceArea_from2010to2020": "เขตพื้นที่การศึกษามัธยมศึกษา เขต 29",
        "RegionFineArts": "สำนักศิลปากรที่ 9 อุบลราชธานี",
        "RegionTAT": "ภาคตะวันออกเฉียงเหนือ",
        "ProvincialOffice_TAT": "การท่องเที่ยวแห่งประเทศไทย (ททท.) สำนักงานอุบลราชธานี",
        "RegionAppealCourt": "ศาลอุทธรณ์ภาค 3",
        "RegionAdministrativeCourt": "ศาลปกครองอุบลราชธานี",
        "RegionTheCriminalCourtforCorruption": "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3",
        "RegionPACC": "สำนักงานป้องกันและปราบปรามการทุจริตในภาครัฐ เขต 3",
        "RegionExciseDepartment": "สำนักงานสรรพสามิตภาคที่ 3",
        "RegionCGDOffice": "สำนักงานคลังเขต 3",
        "RegionRD": "สำนักงานสรรพากรภาค 9",
        "RegionVillageFund": "สำนักงานกองทุนหมู่บ้านและชุมชนเมืองสาขา 8",
        "StateAuditRegionalOffice": "สำนักงานการตรวจเงินแผ่นดินภูมิภาคที่ 5",
        "RegionPRD": "สำนักประชาสัมพันธ์เขต 2",
        "RegionIndustrialRehabilitationCenter": "ศูนย์ฟื้นฟูสมรรถภาพคนงานภาค 4",
        "RegionEducationOffice": "สำนักงานศึกษาธิการภาค 14",
        "RegionHealthPromotionCenter": "ศูนย์อนามัยที่ 10 อุบลราชธานี",
        "RegionMentalHealth": "ศูนย์สุขภาพจิตที่ 10",
        "RegionNHSO": "สำนักงานหลักประกันสุขภาพแห่งชาติ เขต 10 อุบลราชธานี",
        "RegionDisaster": "ศูนย์ป้องกันและบรรเทาสาธารณภัย เขต 13 อุบลราชธานี",
        "RegionHumanSecurity": "สำนักงานส่งเสริมและสนับสนุนวิชาการ 6",
        "RegionOAE": "สำนักงานเศรษฐกิจการเกษตรที่ 11",
        "RegionForestIndustry": "องค์การอุตสาหกรรมป่าไม้ภาคตะวันออกเฉียงเหนือ",
        "RegionMilitaryCircle": "มณฑลทหารบกที่ 22",
        "RegionDSI": "ศูนย์ปฏิบัติการคดีพิเศษเขตพื้นที่ 3",
        "RegionDLD": "สำนักงานปศุสัตว์เขต 3",
        "Region_CustomHouse": "ด่านศุลกากรเขมราฐ, ด่านศุลกากรช่องเม็ก",
        "Region_CustomsBureau": "สำนักงานศุลกากรภาคที่ 2",
        "Region_CAD": "สำนักงานตรวจบัญชีสหกรณ์ที่ 4",
        "Region_DOA": "สำนักวิจัยและพัฒนาการเกษตรเขตที่ 4",
        "Region_MOI": "ภาคตะวันออกเฉียงเหนือ",
        "Region_MOI_Inspection": "เขตตรวจราชการที่ 14",
        "Region_DMR": "สำนักงานทรัพยากรธรณี เขต 2",
        "Region_DIP": "ศูนย์ส่งเสริมอุตสาหกรรมภาคที่ 7 จังหวัดอุบลราชธานี",
        "Region_NESDC_NationalAccounts": "ภาคตะวันออกเฉียงเหนือ",
        "Region_NESDC_RegionalOffice": "สำนักงานพัฒนาเศรษฐกิจและสังคมภาคตะวันออกเฉียงเหนือ",
        "Region_BudgetBureauDivision": "กองจัดทำงบประมาณเขตพื้นที่ 2",
        "RegionSecondaryEducationalServiceArea_from2021": "เขตพื้นที่การศึกษามัธยมศึกษาอุบลราชธานี อำนาจเจริญ",
        "Region_SSOProvincialOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_InspectionArea_CPD": "เขตตรวจราชการที่ 14",
        "Region_DOAE": "สำนักงานส่งเสริมและพัฒนาการเกษตรที่ 4 จังหวัดขอนแก่น",
        "Region_MonkMahaNikai": "ภาค 10",
        "Region_MonkMahaNikai_Hon": "เจ้าคณะใหญ่หนตะวันออก",
        "Region_MonkDhammyuttika": "N/A",
        "Region_OPM_InspectionArea": "เขตตรวจราชการที่ 14",
        "Region_BACCDepartment": "ฝ่ายกิจการสาขาภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_SAT": "สำนักงานการกีฬาแห่งประเทศไทยภาค 3",
        "Region_OPSCulture_RoyalFuneral_Subdivision": "กลุ่มอำนวยการพิธีการศพที่ได้รับพระราชทานที่ 12 อุบลราชธานี",
        "Region_OPSTourismandSports": "ภาคตะวันออกเฉียงเหนือ",
        "Region_TourismDevelopmentArea": "เขตพัฒนาการท่องเที่ยวอารยธรรมอีสานใต้",
        "RiverBasin": "ลุ่มน้ำโขงตะวันออกเฉียงเหนือ, ลุ่มน้ำชี, ลุ่มน้ำมูล",
        "Region_MOE_InspectionArea": "เขตตรวจราชการที่ 14",
        "Region_CTCC": "ศูนย์ถ่ายทอดเทคโนโลยีการสหกรณ์ที่ 6 จังหวัดนครราชสีมา",
        "Region_DMSC": "ศูนย์วิทยาศาสตร์การแพทย์ที่ 10 อุบลราชธานี",
        "Region_DDC": "สำนักงานป้องกันควบคุมโรคที่ 10 จังหวัดอุบลราชธานี",
        "Region_ThailandTrustMark_DITP": "ภาคตะวันออกเฉียงเหนือ",
        "Region_BOI": "ศูนย์เศรษฐกิจการลงทุนภาคที่ 2",
        "Region_OCSB": "ศูนย์ส่งเสริมอุตสาหกรรมอ้อยและน้ำตาลทราย ภาคที่ 4",
        "Region_Archives": "หอจดหมายเหตุแห่งชาติเฉลิมพระเกียรติสมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร อุบลราชธานี",
        "Region_Intelligence": "ศูนย์ประสานข่าวกรองแห่งชาติภาค 3 (ศป.ข.ภาค 3)",
        "Region_StateAuditOffice": "ภาคตะวันออกเฉียงเหนือ",
        "Region_CivicEducationandParticipationCenter": "ศูนย์ส่งเสริมการศึกษาและการมีส่วนร่วมของพลเมืองที่ 7",
        "RegionalHoliday": "ภาคตะวันออกเฉียงเหนือ",
        "Region_Forest": "สำนักจัดการทรัพยากรป่าไม้ที่ 7 สาขาอุบลราชธานี",
        "Region_IrrigationOffice": "สำนักงานชลประทานที่ 7",
        "Region_HydrologyCenter": "ศูนย์อุทกวิทยาชลประทานภาคตะวันออกเฉียงเหนือตอนล่าง",
        "Region_WaterResourceOffice": "สำนักงานทรัพยากรน้ำภาค 11",
        "Region_DMCR": "N/A",
        "DistrictOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ เขต 22",
        "RegionalOffice_NBTC": "สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ภาค 2",
        "Region_CODIOffice": "สำนักงานภาคตะวันออกเฉียงเหนือ",
        "Region_MD_BranchOffice": "สำนักงานเจ้าท่าภูมิภาคสาขาอุบลราชธานี",
        "Region_MD_MarineOffice": "สำนักงานเจ้าท่าภูมิภาคที่ 7",
        "Region_ThailandPost": "สำนักงานไปรษณีย์เขต 10",
        "Region_OccupationalSafety": "ศูนย์ความปลอดภัยในการทำงานเขต 3 (นครราชสีมา)",
        "Region_PrimaryIndustry_Mineral": "สำนักงานอุตสาหกรรมพื้นฐานและการเหมืองแร่ เขต 2 อุดรธานี"
    }
  ]

}
